export const lang: any = {




  '@i18n-validation-constitution-data-date-registryData': 'La fecha de Datos del registro debe ser Menor a la fecha actual',
  '@i18n-validation-constitution-data-date-registryLastUpdate': 'La fecha de Última Modificación debe ser Menor a la fecha actual',



  '@i18n-quote-label-termsAndConditions': ' <a target=blank href={urlDocumentConditions}> el Contrato Único de Productos, Servicios, Canales y Medios de Pago.</a>',
  '@i18n-quote-label-termsAndConditionsDescriptions': "Por medio del presente documento, declaro bajo fe de juramento que todos los datos y documentos suministrados son verdaderos, eximiendo a Rendivalores,  de toda responsabilidad que se derive por información errónea, falsa o inexacta que yo hubiera proporcionado en este documento y/o de los anexo; o de la violación de los mismos¸ que el dinero, o haberes, que se encuentren en la cuenta de Rendivalores, Banco Microfinanciero no tienen relación con actividades producto del delito de legitimación de capitales y/o el financiamiento del terrorismo; así como tampoco provienen de ningún delito previsto en el ordenamiento jurídico vigente. De igual modo declaro que conozco el artículo 214 del Decreto con Rango, Valor y Fuerza de Ley de Instituciones del Sector Bancario publicado en la Gaceta Oficial Extraordinaria N° 6.154 del 19 de Noviembre de 2014, referente a la información falsa para realizar operaciones bancarias, el cual indica:<br> <br> “… Quienes con la intención de defraudar a una institución del sector bancario y a los efectos de celebrar operaciones bancarias, financieras, crediticias o cambiarias, presenten, entreguen o suscriban, balances, estados financieros y en general, documentos o recaudos de cualquier clase que resulten ser falsos, adulterados o forjados o que contengan información o datos que no reflejan razonablemente su verdadera situación financiera, será penados con prisión de diez a quince años y con multa igual al cien por ciento (100%) del monto total distraído…”<br> <br> De igual modo declaro, que los fondos manejados a través de nuestras cuentas son provenientes de actividades lícitas, originados por operaciones realizadas con estricto apego a la legislación vigente y por lo tanto,no contravienen las normas establecidas en la Ley Orgánica de Drogas, Ley Contra la Delincuencia Organizada y Financiamiento al Terrorismo, ni en la Resolución 083.18 “Normas Relativas a la Administración y Fiscalización delos riesgos relacionados con la Legitimación de Capitales, Financiamiento al Terrorismo y Financiamiento de la Proliferación de Armas de Destrucción Masiva aplicables a las Instituciones del Sector Bancario (SUDEBAN) publicadaen la Gaceta Oficial 41.566 de fecha 17 de Enero de 2019, y en tal sentido, autorizo a Rendivalores,  para que verifique los datos por mí suministrados y contenidos en esta Ficha Única.<br> <br> Asimismo declaro que he tenido a la vista, leído, comprendido, y por lo tanto conozco y acepto el contenido del CONTRATO ÚNICO DE PRODUCTOS, SERVICIOS, CANALES Y MEDIOS DE PAGO de Rendivalores, Banco Microfinanciero,C.A. Publicado en el diario EL MUNDO, ECONOMIA Y NEGOCIO, en fecha 26/03/2015, el cual igualmente se encuentra publicado en la portal web (www.acmebank.com.ve) el cual podrá ser actualizado o modificado y publicado o difundidopor los medios o canales dispuesto para ello por El BANCO.",

  '@i18n-verification-questions-what-is-your-person-type': '¿Cuál es su tipo de Persona? (NATURAL o LEGAL)',
  '@i18n-verification-questions-what-is-your-name': '¿Cuál es tu nombre?',
  '@i18n-verification-questions-what-is-your-lastname': '¿Cuál es su apellido?',
  '@i18n-validation-constitution-last-update': 'Si desea cargar datos de Última Modificación, todos los campos son requeridos. En caso contrario, limpie todos los valores de Última Modificación',
  '@i18n-validation-constitution-data-dates': 'La fecha de Última Modificación debe ser Mayor a la fecha de Constitución',
  '@i18n-user-exists-question': 'Ya es cliente o no posee usuario?',

  '@i18n-title-open-account': 'Apertura de Cuenta',
  '@i18n-text-username': 'Usuario',
  '@i18n-text-user-registred': 'Usuario Creado',
  '@i18n-text-thanks': 'Muchas gracias',
  '@i18n-text-select': '-- seleccione --',
  '@i18n-text-resend-code': 'Reenviar código',
  '@i18n-text-recovery-password': 'Recuperar Contraseña',
  '@i18n-text-months': 'Meses',
  '@i18n-text-method-recovery': 'Método',
  '@i18n-text-mail-success-recovery-password': 'Recuperación de contraseña exitosa, ¡le enviamos un correo electrónico con los pasos para configurar su nueva contraseña!',
  '@i18n-text-mail-success': '',
  '@i18n-text-mail': 'Correo',
  '@i18n-text-input-username': 'Ingrese su Usuario',
  '@i18n-text-input-email': 'Ingrese su correo',
  '@i18n-text-input-code': 'Ingrese el código',
  '@i18n-text-identity-validation-subtitle': 'Por su seguridad, necesitamos verificar su identidad. Hemos enviado un código a su correo electrónico',
  '@i18n-text-identity-validation': 'Verificación de<br> identidad',
  '@i18n-text-help-with-your-password-subtitle': 'Seleccione el método de recuperación de contraseña por usuario o correo, ingreselo y presione continuar.',
  '@i18n-text-help-with-your-password': 'Ayuda con la contraseña',
  '@i18n-text-error-field-required': 'Requerido',
  '@i18n-text-email': 'Correo',
  '@i18n-text-check-question-subtitle': 'Tenemos una última pregunta para usted:',
  '@i18n-text-button-send': 'Enviar',
  '@i18n-text-button-continue': 'Continuar',
  '@i18n-text-button-apply': 'Aplicar',
  '@i18n-table-column-update-date': 'Última actualización',
  '@i18n-store-front-login-user-unlock-password': 'Desbloquear',
  '@i18n-store-front-login-user-recovery-password': ' Recuperar Contraseña',
  '@i18n-store-front-login-user-account-create': 'Crear Cuenta de Usuario',
  '@i18n-store-front-login-title': 'Abre y gestiona tu Cuenta de Corretaje Bursátil',
  '@i18n-store-front-login-form-username': 'Usuario',
  '@i18n-store-front-login-form-password': 'Contraseña',
  '@i18n-store-front-login-form-input-username-placeholder': 'Ingrese su usuario',
  '@i18n-store-front-login-form-btn-submit': 'Ingresar',
  '@i18n-store-front-login-error-field-required': 'Campo requerido',
  '@i18n-store-front-login-affiliate': 'Afíliese',
  '@i18n-stage-summary-account-opening': 'Resumen',
  '@i18n-stage-client-dentification': 'Datos de Identificación',
  '@i18n-shareholders-account-opening-step-name': 'Accionistas',
  '@i18n-select-location': 'Seleccione su ubicación',
  '@i18n-section-title-foreignMobilizationInformation': '¿Desea enviar o recibir fondos del exterior?',
  '@i18n-section-title-constitution-data-public-body': 'Ente Público',
   '@i18n-section-title-constitution-data-last-update': 
  `

  
  <div class="text-secondary font-weight-normal alert alert-warning p-3 mt-4 mb-4 animate__animated animate__fadeIn fz-14 ">
       <span >En caso de haber realizado actualizaciones al Registro Mercantil tales como ventas o traspaso de acciones; aumento de capital; y/o nombramiento de Junta Directiva por favor registre a continuación la última modificación.
       </span>
 </div>

  Última modificación
  `,  '@i18n-section-title-constitution-data': 'Datos del registro',
  '@i18n-related-persons-account-opening-step-name': 'Personas Relacionadas',
  '@i18n-references-account-opening-step-name': 'Cuentas Bancarias',
  '@i18n-quote-suppliers-suppliersTable-section.title': '',
  '@i18n-quote-suppliers-section.title': 'Principales Proveedores',
  '@i18n-quote-suppliers-modal-section-title': 'Principales Proveedores',
  '@i18n-quote-shareholders-shareholdersTable-section.title': 'Accionistas',
  '@i18n-quote-shareholders-sections-description': '',
  '@i18n-quote-shareholders-section.title': 'Accionistas',
  '@i18n-quote-shareholders-pep-modal-section-title': 'Persona Políticamente Expuesta',
  '@i18n-quote-shareholders-modal-section-title': 'Accionista',
  '@i18n-quote-shareholders-form-label-shareholderType': 'Tipo de Accionista',
  '@i18n-quote-shareholders-form-label-sharePercentage': 'Porcentaje accionario',
  '@i18n-quote-response-form-label-response': 'Respuesta',
  '@i18n-quote-response-form-label-comments': 'Comentarios',
  '@i18n-quote-relatedPerson-form-label-taxId': 'Número de Identificación Fiscal',
  '@i18n-quote-relatedPerson-form-label-state': 'Estado',
  '@i18n-quote-relatedPerson-form-label-secondName': 'Segundo Nombre',
  '@i18n-quote-relatedPerson-form-label-name': 'Nombre o Razón Social',
  '@i18n-quote-relatedPerson-form-label-firstName':'Primer nombre',
  '@i18n-quote-relatedPerson-form-label-economicActivity': 'Actividad Económica',
  '@i18n-quote-relatedPerson-form-label-country': 'País',
  '@i18n-quote-relatedPerson-form-label-businessName': 'Razón Social',
  '@i18n-quote-relatedPerson-form-label-applicantType': 'Tipo de Persona',
  '@i18n-quote-relatedCompanies-section.title': 'Empresas relacionadas',
  '@i18n-quote-relatedCompanies-relatedCompaniesTable-section.title': '',
  '@i18n-quote-relatedCompanies-modal-section-title': 'Empresas Relacionadas',
  '@i18n-quote-relatedCompanies-checkRelatedCompanies-section.title': '',
  '@i18n-quote-publicBody-form-label-gazetteNumber': 'Número de Gaceta',
  '@i18n-quote-publicBody-form-label-gazetteDate': 'Fecha',
  '@i18n-quote-publicBody-form-label-affiliationBody': 'Autoridad / Ente de Adscripción',
  '@i18n-quote-publicBody-form-label-ONTCode': 'Código ONT',
  '@i18n-quote-productInformation-form-label-virtualCoin': 'Uso de moneda virtual',
  '@i18n-quote-productInformation-form-label-sourceOfFunds': 'Origen de los fondos',
  '@i18n-quote-productInformation-form-label-productNumber': 'Número de Cuenta',
  '@i18n-quote-productInformation-form-label-productName': 'Nombre del Producto',
  '@i18n-quote-productInformation-form-label-destinationOfFunds': 'Destino de los fondos',
  '@i18n-quote-productInformation-form-label-countryMobilizationOrigin': 'País de origen',
  '@i18n-quote-productInformation-form-label-countryMobilizationDestiny': 'País destino',
  '@i18n-quote-personalInformation-personalInformationFields-section.title': '',
  '@i18n-quote-option-list-specialCategory-option16': 'PERSONAS NATURALES O JURÍDICAS QUE SE DEDIQUEN REGULARMENTE O HABITUALMENTE AL OTORGAMIENTO DE CRÉDITOS O A EFECTUAR DESCUENTOS O INVERSIONES CON SUS PROPIOS FONDOS',
  '@i18n-quote-option-list-specialCategory-option15': 'PERSONAS NATURALES  O JURÍDICAS DEDICADAS HABITUALMENTE A LA COMERCIALIZACIÓN DIRECTA O INDIRECTA DE MONEDAS VIRTUALES',
  '@i18n-quote-option-list-specialCategory-option14': 'PERSONAS JURÍDICAS CONSTITUIDAS Y ESTABLECIDAS EN PAÍSES, ESTADOS O JURISDICCIÓN QUE POSEAN UN SISTEMA FISCAL DIFERENCIADO ENTRE RESIDENTES Y NACIONALES, ESTRICTO SECRETO BANCARIO, CARENCIA DE TRATADOS INTERNACIONALES EN LA MATERIA.',
  '@i18n-quote-option-list-specialCategory-option13': 'PERSONAS EXPUESTAS POLÍTICAMENTE (PEP), INCUYENDO A FAMILIARES CERCANOS, ASOCIADOS Y ESTRECHO COLABORADORES DE DICHA PERSONAS',
  '@i18n-quote-option-list-specialCategory-option12': 'OPERADORES CAMBIARIOS FRONTERIZOS',
  '@i18n-quote-option-list-specialCategory-option11': 'JUEGOS DE ENVITE Y AZAR ',
  '@i18n-quote-option-list-specialCategory-option10': 'INVERSIONISTAS Y AGENCIAS DE BIENES RAÍCES',
  '@i18n-quote-option-list-specialCategory-option9': 'EMPRESAS DEDICADAS A LA TRANSFERENCIA O ENVÍO DE FONDOS O REMESA',
  '@i18n-quote-option-list-specialCategory-option8': 'COMERCIALIZADORES DE ARMAS, EXPLOSIVOS Y MUNICIONES',
  '@i18n-quote-option-list-specialCategory-option7': 'COMERCIALIZADORES DE ANTIGUEDADES, JOYAS, METALES Y PIEDRAS PRECIOSAS, MONEDAS, OBJETO DE ARTE Y SELLOS POSTALES',
  '@i18n-quote-option-list-specialCategory-option6': 'COMERCIALIZADORAS Y ARRENDADORAS DE VEHÍCULOS AUTOMOTORES, EMBARCACIONES Y AERONAVES.',
  '@i18n-quote-option-list-specialCategory-option5': 'CASINO Y SALAS DE JUEGO',
  '@i18n-quote-option-list-specialCategory-option4': 'CASAS DE EMPEÑO ',
  '@i18n-quote-option-list-specialCategory-option3': 'CASAS DE CAMBIO NACIONALES O INTERNACIONALES DOMICILIADAS O NO EN EL PAÍS',
  '@i18n-quote-option-list-specialCategory-option2': 'ASOCIACIONES CIVILES SIN FINES DE LUCRO O FUNDACIONES U ORGANISMOS NO GUBERNAMENTALES (ONG´S)',
  '@i18n-quote-option-list-specialCategory-option1': 'ABOGADOS, CONTADORES PÚBLICOS Y OTROS PROFESIONALES INDEPENDIENTES',
  '@i18n-quote-option-list-sourceOfFunds-option16': 'VENTA DE MONEDA VIRTUAL',
  '@i18n-quote-option-list-sourceOfFunds-option15': 'VENTA DE OBRAS DE ARTE Y/O ARTÍCULOS PERSONALES',
  '@i18n-quote-option-list-sourceOfFunds-option14': 'SERVICIOS PROFESIONALES (ASESORES)',
  '@i18n-quote-option-list-sourceOfFunds-option13': 'SALARIO FIJO',
  '@i18n-quote-option-list-sourceOfFunds-option12': 'RIFAS, LOTERÍAS Y OTROS SORTEOS',
  '@i18n-quote-option-list-sourceOfFunds-option11': 'RETIRO DE OTROS BANCOS',
  '@i18n-quote-option-list-sourceOfFunds-option10': 'PENSIÓN Y JUBILACIÓN',
  '@i18n-quote-option-list-sourceOfFunds-option9': 'PAGO DE PRÉSTAMO',
  '@i18n-quote-option-list-sourceOfFunds-option8': 'MANEJO DE TRANSPORTE PÚBLICO Y PRIVADO (TAXI Y BUSETAS)',
  '@i18n-quote-option-list-sourceOfFunds-option7': 'LIBRE EJERCICIO DE PROFESIÓN',
  '@i18n-quote-option-list-sourceOfFunds-option6': 'INGRESOS A TRAVÉS DE TERCEROS (AMA DE CASA Y ESTUDIANTES)',
  '@i18n-quote-option-list-sourceOfFunds-option5': 'ECONOMÍA INFORMAL',
  '@i18n-quote-option-list-sourceOfFunds-option4': 'COMERCIALIZACIÓN DE PÓLIZAS DE SEGUROS',
  '@i18n-quote-option-list-sourceOfFunds-option3': 'ALQUILER DE BIENES',
  '@i18n-quote-option-list-sourceOfFunds-option2': 'ALQUILER DE HERRAMIENTAS Y EQUIPOS',
  '@i18n-quote-option-list-sourceOfFunds-option1': 'ACTIVIDAD COMERCIAL DE EMPRESA PROPIA',


  
  '@i18n-quote-option-list-economicactivity3-option272': 'ZAPATERIAS',
  '@i18n-quote-option-list-economicactivity3-option271': 'VETERINARIOS',
  '@i18n-quote-option-list-economicactivity3-option270': 'VENTA POR MAYOR Y MENOR DE BEBIDAS NO ALCOHOLICAS Y AGUAS MINERA',
  '@i18n-quote-option-list-economicactivity3-option269': 'VENTA DE VEHICULOS AUTOMOTORES',
  '@i18n-quote-option-list-economicactivity3-option268': 'VENTA DE PARTES, PIEZAS Y ACCESORIOS DE VEHICULOS AUTOMOTORES.',
  '@i18n-quote-option-list-economicactivity3-option267': 'VENTA DE MOTOCICLETAS.',
  '@i18n-quote-option-list-economicactivity3-option266': 'VENTA DE GAS DE USO DOMESTICO E INDUSTRIAL',
  '@i18n-quote-option-list-economicactivity3-option265': 'VENTA DE COMIDA EN FERIAS, KIOSCOS, CANTINAS',
  '@i18n-quote-option-list-economicactivity3-option264': 'VENTA DE BEBIDAS ALCOHOLICAS (DISTRIBUIDORA, LICORERIAS)',
  '@i18n-quote-option-list-economicactivity3-option263': 'VENTA DE ABONOS, FERTILIZANTES, COMIDA PARA ANIMALES, PLAGUICIDA',
  '@i18n-quote-option-list-economicactivity3-option262': 'VENTA AL POR MENOR DE RELOJES, JOYAS Y ARTICULOS CONEXOS',
  '@i18n-quote-option-list-economicactivity3-option261': 'VENTA AL POR MENOR DE PLANTAS Y FLORES. FLORERIAS',
  '@i18n-quote-option-list-economicactivity3-option260': 'VENTA AL POR MENOR DE COSMETICOS Y ARTICULOS DE TOCADOR (PERFUME)',
  '@i18n-quote-option-list-economicactivity3-option259': 'VENTA AL POR MENOR DE ARTICULOS DE DECORACION',
  '@i18n-quote-option-list-economicactivity3-option258': 'VENTA AL POR MAYOR DE PRODUCTOS ALIMENTICIOS ELABORADOS',
  '@i18n-quote-option-list-economicactivity3-option257': 'VENTA AL POR MAYOR DE OTROS PRODUCTOS',
  '@i18n-quote-option-list-economicactivity3-option256': 'VENTA AL POR MAYOR DE MAQUINARIA, EQUIPO Y MATERIALES',
  '@i18n-quote-option-list-economicactivity3-option255': 'VENTA AL POR MAYOR DE GANADO EN PIE (BOVINOS, OVINOS, EQUINOS, P',
  '@i18n-quote-option-list-economicactivity3-option254': 'VENTA AL POR MAYOR DE EQUIPO PARA RESTAURANTES, HOTELES, ETC.',
  '@i18n-quote-option-list-economicactivity3-option253': 'VENTA AL POR MAYOR DE ENSERES DOMESTICOS Y ARTICULOS DEL HOGAR.',
  '@i18n-quote-option-list-economicactivity3-option252': 'VENTA AL MAYOR Y DETAL DE PRODUCTOS DE LIMPIEZA E HIGIENE INDUSTRIAL Y/O HOGAR',
  '@i18n-quote-option-list-economicactivity3-option251': 'TRANSPORTE TERRESTRE URBANo EXTRAURBANO',
  '@i18n-quote-option-list-economicactivity3-option250': 'TRANSPORTE POR VIA TERRESTRE; TRANSPORTE POR TUBERIAS',
  '@i18n-quote-option-list-economicactivity3-option249': 'TRANSPORTE POR VIA AEREA',
  '@i18n-quote-option-list-economicactivity3-option248': 'TRANSPORTE POR VIA ACUATICA',
  '@i18n-quote-option-list-economicactivity3-option247': 'TRANSPORTE MARITIMO DE CARGA Y PASAJEROS',
  '@i18n-quote-option-list-economicactivity3-option246': 'TRANSPORTE FERROVIARIO DE CARGA Y PASAJEROS',
  '@i18n-quote-option-list-economicactivity3-option245': 'TRANSPORTE ESCOLAR / TURISMO',
  '@i18n-quote-option-list-economicactivity3-option244': 'TRANSPORTE DE VALORES, DOCUMENTACION, ENCOMIENDA Y SIMILARES',
  '@i18n-quote-option-list-economicactivity3-option243': 'TRANSPORTE ALMACENAMIENTO Y COMUNICACIONES',
  '@i18n-quote-option-list-economicactivity3-option242': 'TRANSPORTE AEREO DE CARGA Y PASAJEROS',
  '@i18n-quote-option-list-economicactivity3-option241': 'TERMINACION DE EDIFICIOS (INCLUYE TERMINACION Y ACABADO DE LA OBRAS)',
  '@i18n-quote-option-list-economicactivity3-option240': 'TELEVISORAS POR SEÑAL ABIERTA',
  '@i18n-quote-option-list-economicactivity3-option239': 'TELEVISION POR CABLE O SATELITE',
  '@i18n-quote-option-list-economicactivity3-option238': 'TELECOMUNICACIONES',
  '@i18n-quote-option-list-economicactivity3-option237': 'TALLER DE REPARACION, LIMPIEZA, LAVADO, PULIDO DE VEHICULOS / MOTOS',
  '@i18n-quote-option-list-economicactivity3-option236': 'SUMINISTRO DE ELECTRICIDAD, GAS, VAPOR Y AIRE ACONDICIONADO',
  '@i18n-quote-option-list-economicactivity3-option235': 'SILVICULTURA Y EXTRACCION DE MADERA',
  '@i18n-quote-option-list-economicactivity3-option234': 'SERVICIOS SOCIALES Y OTROS COMUNALES Y CONEXOS',
  '@i18n-quote-option-list-economicactivity3-option233': 'SERVICIOS SOCIALES Y OTROS COMUNALES NO CLASIFICADOS',
  '@i18n-quote-option-list-economicactivity3-option232': 'SERVICIOS RELACIONADOS CON EL TRANSPORTE NO CLASIFICADO EN OTRA',
  '@i18n-quote-option-list-economicactivity3-option231': 'SERVICIOS PERIODISTICOS PUBLICOS Y PRIVADOS',
  '@i18n-quote-option-list-economicactivity3-option230': 'SERVICIOS MEDICOS Y ODONTOLOGICOS, OTROS SANIDAD',
  '@i18n-quote-option-list-economicactivity3-option229': 'SERVICIOS FUNERARIOS, CASAS DE SEPELIOS Y ACTIVIDADES CONEXAS.',
  '@i18n-quote-option-list-economicactivity3-option228': 'SERVICIOS FINANCIEROS, EXCEPTO SEGUROS Y FONDOS DE PENSIONES',
  '@i18n-quote-option-list-economicactivity3-option227': 'SERVICIOS DE TELECOMUNICACIONES NO ESPECIFICADAS EN OTRA PARTE',
  '@i18n-quote-option-list-economicactivity3-option226': 'SERVICIOS DE SEGURIDAD PRIVADA, EMPRESAS DE VIGILANCIA Y RELACIONADAS',
  '@i18n-quote-option-list-economicactivity3-option225': 'SERVICIOS DE SANEAMIENTO Y SIMILARES',
  '@i18n-quote-option-list-economicactivity3-option224': 'SERVICIOS DE PRACTICAS DEPORTIVAS (INCLUYE CLUBES, GIMNASIOS)',
  '@i18n-quote-option-list-economicactivity3-option223': 'SERVICIOS DE MUDANZA / MANIPULACION DE CARGAS',
  '@i18n-quote-option-list-economicactivity3-option222': 'SERVICIOS DE IMPRESION, FOTOCOPIADO, CYBERG, ENCUADERNACION Y C',
  '@i18n-quote-option-list-economicactivity3-option221': 'SERVICIOS DE FOTOGRAFIA. ESTUDIOS Y LABORATORIOS FOTOGRAFICOS. R',
  '@i18n-quote-option-list-economicactivity3-option220': 'SERVICIOS DE DIVERSION Y ESPARCIMIENTO NO CLASIFICADOS',
  '@i18n-quote-option-list-economicactivity3-option219': 'SERVICIOS DE DIVERSION DE ESPARCIMIENTO Y CULTURALES',
  '@i18n-quote-option-list-economicactivity3-option218': 'SERVICIOS DE CONTADURIA, ADMINISTRADORAS',
  '@i18n-quote-option-list-economicactivity3-option217': 'SERVICIOS DE ASOC. COMERCIALES, PROFESIONALES Y LABORALES (COOPERATIVAS)',
  '@i18n-quote-option-list-economicactivity3-option216': 'SERVICIOS DE ASISTENCIA SOCIAL (AMBULANCIAS, LABORATORIOS)',
  '@i18n-quote-option-list-economicactivity3-option215': 'SERVICIOS CINEMATOGRAFICOS, RADIO Y TELEVISION, TEATRO Y MUSICA',
  '@i18n-quote-option-list-economicactivity3-option214': 'SERVICIOS AGROPECUARIOS (FUMIGACION, RECOLECCION Y ALQUILER DE M',
  '@i18n-quote-option-list-economicactivity3-option213': 'SERVICIO, COMUNALES, SOCIALES Y PERSONALES',
  '@i18n-quote-option-list-economicactivity3-option212': 'SERVICIO DOMESTICO, AMA DE LLAVES, CHOFER',
  '@i18n-quote-option-list-economicactivity3-option211': 'SERVICIO DE TRANSPORTE PRIVADO (TAXI, MOTO TAXI, EXCURSION, VIAJE)',
  '@i18n-quote-option-list-economicactivity3-option210': 'SERVICIO DE TELEFONIA FIJA Y CELULAR',
  '@i18n-quote-option-list-economicactivity3-option209': 'SERVICIO DE ALIMENTO Y BEBIDA',
  '@i18n-quote-option-list-economicactivity3-option208': 'SEGUROS, REASEGUROS Y FONDOS DE PENSIONES, EXCEPTO LOS PLANES DE SEGURIDAD SOCIAL DE AFILIACION OBLIGATORIA',
  '@i18n-quote-option-list-economicactivity3-option207': 'SEGUROS',
  '@i18n-quote-option-list-economicactivity3-option206': 'SALONES DE BAILE, DISCOTECAS Y SIMILARES',
  '@i18n-quote-option-list-economicactivity3-option205': 'RESTAURANTES Y CAFES',
  '@i18n-quote-option-list-economicactivity3-option204': 'REPARACION E INSTALACION DE LA MAQUINARIA Y EQUIPO',
  '@i18n-quote-option-list-economicactivity3-option203': 'REPARACION E INSTALACION DE LA MAQUINARIA Y  EQUIPO',
  '@i18n-quote-option-list-economicactivity3-option202': 'REPARACION DE ARTEFACTOS ELECTRICOS',
  '@i18n-quote-option-list-economicactivity3-option201': 'REFINERIAS DE PETROLEO',
  '@i18n-quote-option-list-economicactivity3-option200': 'RECOLECCION, TRATAMIENTO Y ELIMINACION DE DESECHOS, RECUPERACION DE MATERIALES',
  '@i18n-quote-option-list-economicactivity3-option199': 'RECICLAMIENTO (MATERIAL U ORGANICO)',
  '@i18n-quote-option-list-economicactivity3-option198': 'PRODUCCION Y PROCESAMIENTO DE CARNES Y PESCADO',
  '@i18n-quote-option-list-economicactivity3-option197': 'PRODUCCION Y PROCESAMIENTO DE  FRUTAS, LEGUMBRES, HORTALIZAS, ETC.',
  '@i18n-quote-option-list-economicactivity3-option196': 'PRODUCCION DE PETROLEO CRUDO Y GAS NATURAL',
  '@i18n-quote-option-list-economicactivity3-option195': 'PRODUCCION DE MADERA Y FABRICACION DE PRODUCTOS DE MADERA Y CORCHO, EXCEPTO MUEBLES FABRICACION DE ARTICULOS DE PAJA Y DE MATERIALES TRENZABLES',
  '@i18n-quote-option-list-economicactivity3-option194': 'PRODUCCION DE ESPECTACULOS DEPORTIVOS',
  '@i18n-quote-option-list-economicactivity3-option193': 'PROCESAMIENTO DE DATOS',
  '@i18n-quote-option-list-economicactivity3-option192': 'PREPARACION DEL TERRENO',
  '@i18n-quote-option-list-economicactivity3-option191': 'PIZZERIA, COMIDA RAPIDA (FRANQUICIA), HELADERIAS',
  '@i18n-quote-option-list-economicactivity3-option190': 'PESCA Y ACUICULTURA',
  '@i18n-quote-option-list-economicactivity3-option189': 'PESCA MARITIMA (DE ALTURA Y COSTERA).',
  '@i18n-quote-option-list-economicactivity3-option188': 'PESCA FLUVIAL Y LACUSTRE (CONTINENTAL).',
  '@i18n-quote-option-list-economicactivity3-option187': 'PELUQUERIA Y OTROS TRATAMIENTOS DE BELLEZA.',
  '@i18n-quote-option-list-economicactivity3-option186': 'PANADERIAS, CAFETERIAS, CHARCUTERIAS, PASTELERIAS',
  '@i18n-quote-option-list-economicactivity3-option185': 'OTROS TIPOS DE VENTAS AL POR MENOR EN ALMACENES ESPECIALIZADOS',
  '@i18n-quote-option-list-economicactivity3-option184': 'OTROS TIPOS DE TRANSPORTE REGULAR DE CARGA POR VIA TERRESTRE',
  '@i18n-quote-option-list-economicactivity3-option183': 'OTROS RELACIONADOS A LA CONSTRUCCION',
  '@i18n-quote-option-list-economicactivity3-option182': 'OTROS ELECTRICIDAD GAS AGUA',
  '@i18n-quote-option-list-economicactivity3-option181': 'OTROS COMERCIOS',
  '@i18n-quote-option-list-economicactivity3-option180': 'OTRAS INDUSTRIAS MANUFACTURERAS',
  '@i18n-quote-option-list-economicactivity3-option179': 'OTRAS ACTIVIDADES VINCULADAS A MINAS E HIDROCARBUROS',
  '@i18n-quote-option-list-economicactivity3-option178': 'OTRAS ACTIVIDADES FINANCIERAS',
  '@i18n-quote-option-list-economicactivity3-option177': 'OTRAS ACTIVIDADES FINACIERAS',
  '@i18n-quote-option-list-economicactivity3-option176': 'OTRAS ACTIVIDADES DE SERVICIOS PERSONALES Y DEL HOGAR.',
  '@i18n-quote-option-list-economicactivity3-option175': 'OTRAS ACTIVIDADES DE SANEAMIENTO.',
  '@i18n-quote-option-list-economicactivity3-option174': 'OTRAS ACTIVIDADES DE INFORMATICA.',
  '@i18n-quote-option-list-economicactivity3-option173': 'OTRAS ACTIVIDADES DE AGRICULTURA, PESCA Y GANADERIA',
  '@i18n-quote-option-list-economicactivity3-option172': 'OPTICAS',
  '@i18n-quote-option-list-economicactivity3-option171': 'MUSICO, CANTANTE, ARTISTA',
  '@i18n-quote-option-list-economicactivity3-option170': 'MUEBLERIAS',
  '@i18n-quote-option-list-economicactivity3-option169': 'MINAS E HIDROCARBUROS',
  '@i18n-quote-option-list-economicactivity3-option168': 'MICROEMPRESARIO (VENTA AL POR MENOR EN PUESTOS DE VENTA Y EN MERCADOS)',
  '@i18n-quote-option-list-economicactivity3-option167': 'MANTENIMIENTO Y REPARACION DE VEHICULOS AUTOMOTORES.',
  '@i18n-quote-option-list-economicactivity3-option166': 'MANTENIMIENTO Y REPARACION DE MOTOCICLETAS.',
  '@i18n-quote-option-list-economicactivity3-option165': 'MANTENIMIENTO Y REPARACION DE MAQUINARIA DE OFICINA, CONTABILIDAD',
  '@i18n-quote-option-list-economicactivity3-option164': 'LIMPIEZA URBANA Y RECOLECCION DE RESIDUOS',
  '@i18n-quote-option-list-economicactivity3-option163': 'LIBRERIAS, PAPELERIAS, VENTA DE MATERIALES DE OFICINA',
  '@i18n-quote-option-list-economicactivity3-option162': 'LAVADO, LIMPIEZA Y TEÑIDO DE PRENDAS DE TELA O DE PIEL.',
  '@i18n-quote-option-list-economicactivity3-option161': 'JUGUETERIAS',
  '@i18n-quote-option-list-economicactivity3-option160': 'JUEGOS DE SALON (BINGO, BILLAR, POOL, BOWLING, JUEGOS ELECTRONICOS)',
  '@i18n-quote-option-list-economicactivity3-option159': 'INSTRUCCION Y ENSEÑANZA (BASICA Y SUPERIOR)',
  '@i18n-quote-option-list-economicactivity3-option158': 'INGENIERIA CIVIL',
  '@i18n-quote-option-list-economicactivity3-option157': 'INDUSTRIAS MANUFACTURERAS',
  '@i18n-quote-option-list-economicactivity3-option156': 'IMPRENTAS, EDITORIALES O INDUSTRIAS CONEXAS',
  '@i18n-quote-option-list-economicactivity3-option155': 'GRANDES TIENDAS Y ALMACENES. TIENDAS Y ALMACENES MINORISTAS POR',
  '@i18n-quote-option-list-economicactivity3-option154': 'GENERACION, CAPTACION Y DISTRIBUCION DE ENERGIA ELECTRICA',
  '@i18n-quote-option-list-economicactivity3-option153': 'GASOLINERAS / ESTACIONES DE SUMINISTROS DE GASOLINA Y DIESEL',
  '@i18n-quote-option-list-economicactivity3-option152': 'GALERIAS DE ARTE; CASAS DE ANTIGÜEDADES',
  '@i18n-quote-option-list-economicactivity3-option151': 'FUNDICION DE METALES',
  '@i18n-quote-option-list-economicactivity3-option150': 'FUMIGACION, DESINFECCION, EXTERMINIO DE INSECTOS Y PLAGAS',
  '@i18n-quote-option-list-economicactivity3-option149': 'FRIGORIFICOS, CARNICERIA, PESCADERIA',
  '@i18n-quote-option-list-economicactivity3-option148': 'FORESTACION (PLANTACION, REPOBLACION, CONSERVACION DE BOSQUES Y',
  '@i18n-quote-option-list-economicactivity3-option147': 'FINANCIERAS,SEGUROS,INMUEBLES,SERV.TEC Y PROF Y',
  '@i18n-quote-option-list-economicactivity3-option146': 'FERRETERIAS Y MATERIALES DE CONSTRUCCION Y PINTURA (ARENA, BLOQUES)',
  '@i18n-quote-option-list-economicactivity3-option145': 'FARMACIAS, DROGUERIAS Y CASAS NATURISTAS',
  '@i18n-quote-option-list-economicactivity3-option144': 'FABRICACION Y ENSAMBLADO DE VEHICULOS AUTOMOTORES.',
  '@i18n-quote-option-list-economicactivity3-option143': 'FABRICACION DE VIDRIO Y PRODUCTOS DE VIDRIO',
  '@i18n-quote-option-list-economicactivity3-option142': 'FABRICACION DE VEHICULOS AUTOMOTORES, REMOLQUES Y SEMIRREMOLQUES',
  '@i18n-quote-option-list-economicactivity3-option141': 'FABRICACION DE TEXTILES (TELAS, ALFOMBRAS, LENCERIA, CORTINAS)',
  '@i18n-quote-option-list-economicactivity3-option140': 'FABRICACION DE SUSTANCIAS Y  PRODUCTOS QUIMICOS',
  '@i18n-quote-option-list-economicactivity3-option139': 'FABRICACION DE SUSTANCIAS QUIMICAS E INDUSTRIALES',
  '@i18n-quote-option-list-economicactivity3-option138': 'FABRICACION DE PRODUCTOS TEXTILES',
  '@i18n-quote-option-list-economicactivity3-option137': 'FABRICACION DE PRODUCTOS QUIMICOS NO CLASIFICADOS EN OTRA PARTE',
  '@i18n-quote-option-list-economicactivity3-option136': 'FABRICACION DE PRODUCTOS PRIMARIOS DE HIERRO Y ACERO.',
  '@i18n-quote-option-list-economicactivity3-option135': 'FABRICACION DE PRODUCTOS NO CLASIFICADOS',
  '@i18n-quote-option-list-economicactivity3-option134': 'FABRICACION DE PRODUCTOS METALICOS, MAQUINARIAS Y EQUIPOS',
  '@i18n-quote-option-list-economicactivity3-option133': 'FABRICACION DE PRODUCTOS METALICOS, EXCEPTO MAQUINARIAS Y EQUIPO',
  '@i18n-quote-option-list-economicactivity3-option132': 'FABRICACION DE PRODUCTOS FARMACEUTICOS, SUSTANCIAS QUIMICAS MEDICINALES Y DE PRODUCTOS BOTANICOS',
  '@i18n-quote-option-list-economicactivity3-option131': 'FABRICACION DE PRODUCTOS FARMACEUTICOS, SUSTANCIAS QUIMICAS MEDICAS',
  '@i18n-quote-option-list-economicactivity3-option130': 'FABRICACION DE PRODUCTOS DE PLASTICO',
  '@i18n-quote-option-list-economicactivity3-option129': 'FABRICACION DE PRODUCTOS DE MADERA, CORCHO, PAJA Y MATERIALES TR',
  '@i18n-quote-option-list-economicactivity3-option128': 'FABRICACION DE PRODUCTOS DE CAUCHO',
  '@i18n-quote-option-list-economicactivity3-option127': 'FABRICACION DE PRENDAS DE VESTIR',
  '@i18n-quote-option-list-economicactivity3-option126': 'FABRICACION DE PRENDAS DE VESTIR',
  '@i18n-quote-option-list-economicactivity3-option125': 'FABRICACION DE PINTURAS, BARNICES Y PRODUCTOS DE REVESTIMIENTO S',
  '@i18n-quote-option-list-economicactivity3-option124': 'FABRICACION DE PARTES Y REPUESTOS PARA VEHICULOS AUTOMOTORES',
  '@i18n-quote-option-list-economicactivity3-option123': 'FABRICACION DE PAPEL, CARTON Y SUS DERIVADOS',
  '@i18n-quote-option-list-economicactivity3-option122': 'FABRICACION DE PAPEL Y DE LOS PRODUCTOS DE PAPEL',
  '@i18n-quote-option-list-economicactivity3-option121': 'FABRICACION DE OTROS TIPOS DE EQUIPO DE TRANSPORTE',
  '@i18n-quote-option-list-economicactivity3-option120': 'FABRICACION DE OTROS TIPO DE EQUIPO DE TRANSPORTE (BARCOS, TRENES)',
  '@i18n-quote-option-list-economicactivity3-option119': 'FABRICACION DE OTROS PRODUCTOS MINERALES NO METALICOS',
  '@i18n-quote-option-list-economicactivity3-option118': 'FABRICACION DE MUEBLES DE HOGAR Y DE OFICINA',
  '@i18n-quote-option-list-economicactivity3-option117': 'FABRICACION DE MUEBLES',
  '@i18n-quote-option-list-economicactivity3-option116': 'FABRICACION DE METALES COMUNES',
  '@i18n-quote-option-list-economicactivity3-option115': 'FABRICACION DE MAQUINARIA Y APARATOS ELECTRICOS (MOTORES, LAMPARAS)',
  '@i18n-quote-option-list-economicactivity3-option114': 'FABRICACION DE MAQUINARIA DE OFICINA, CONTABILIDAD E INFORMATICA',
  '@i18n-quote-option-list-economicactivity3-option113': 'FABRICACION DE LOS PRODUCTOS INFORMATICOS, ELECTRONICOS Y OPTICOS',
  '@i18n-quote-option-list-economicactivity3-option112': 'FABRICACION DE LA MAQUINARIA Y  EQUIPO N C P',
  '@i18n-quote-option-list-economicactivity3-option111': 'FABRICACION DE INSTRUMENTOS Y EQUIPOS MEDICOS',
  '@i18n-quote-option-list-economicactivity3-option110': 'FABRICACION DE GAS; DISTRIBUCION DE COMBUSTIBLES GASEOSOS',
  '@i18n-quote-option-list-economicactivity3-option109': 'FABRICACION DE EQUIPOS DE TV, AUDIO, VIDEO Y COMUNICACIONES',
  '@i18n-quote-option-list-economicactivity3-option108': 'FABRICACION DE EQUIPO PROFESIONAL Y CIENTIFICO',
  '@i18n-quote-option-list-economicactivity3-option107': 'FABRICACION DE EQUIPO ELECTRICO',
  '@i18n-quote-option-list-economicactivity3-option106': 'FABRICACION DE CUEROS Y PRODUCTOS CONEXOS',
  '@i18n-quote-option-list-economicactivity3-option105': 'FABRICACION DE CERAMICAS, ARENAS , BALDOSAS, CAL, YESO, CONCRETO',
  '@i18n-quote-option-list-economicactivity3-option104': 'FABRICACION DE CALZADO (VESTIR Y DEPORTIVO)',
  '@i18n-quote-option-list-economicactivity3-option103': 'FABRICACION DE APARATOS DE USO DOMESTICO',
  '@i18n-quote-option-list-economicactivity3-option102': 'FABRICACION DE  PRODUCTOS DERIVADOS DEL METAL, EXCEPTO  MAQUINARIA YEQUIPO',
  '@i18n-quote-option-list-economicactivity3-option101': 'FABRICACION DE  PRODUCTOS DE CAUCHO Y  PLASTICO',
  '@i18n-quote-option-list-economicactivity3-option100': 'FABRICACION  DE COQUE Y DE  PRODUCTOS DE LA  REFINACION  DEL PETROLEO',
  '@i18n-quote-option-list-economicactivity3-option99': 'FAB.SUST.QUIMICAS Y PROD. QUIMICOS DERIVADOS DEL PETROLEO',
  '@i18n-quote-option-list-economicactivity3-option98': 'EXTRACCION DE PETROLEO CRUDO Y GAS NATURAL',
  '@i18n-quote-option-list-economicactivity3-option97': 'EXTRACCION DE OTROS MINERALES',
  '@i18n-quote-option-list-economicactivity3-option96': 'EXTRACCION DE MINERALES METALIFEROS',
  '@i18n-quote-option-list-economicactivity3-option95': 'EXTRACCION DE MINERALES METALICOS',
  '@i18n-quote-option-list-economicactivity3-option94': 'EXTRACCION DE MADERA. CORTE, DESBASTE DE TRONCO Y MADERA EN BRUTO',
  '@i18n-quote-option-list-economicactivity3-option93': 'EXTRACCION DE CARBON Y LIGNITO, EXTRACCION DE TURBA',
  '@i18n-quote-option-list-economicactivity3-option92': 'EXPLOTACION DE OTRAS MINAS Y CANTERAS',
  '@i18n-quote-option-list-economicactivity3-option91': 'EXPLOTACION DE OTRAS MINAS O CANTERAS',
  '@i18n-quote-option-list-economicactivity3-option90': 'EXPLOTACION DE MINAS DE CARBON',
  '@i18n-quote-option-list-economicactivity3-option89': 'EXPLOTACION DE CRIADEROS O VIVEROS DE PECES Y OTROS FRUTOS ACUATICOS',
  '@i18n-quote-option-list-economicactivity3-option88': 'EXPLOTACION DE BOSQUES SIN REPLANTACION',
  '@i18n-quote-option-list-economicactivity3-option87': 'ESTACIONAMIENTOS; GARAJES',
  '@i18n-quote-option-list-economicactivity3-option86': 'ENSEÑANZA TECNICA Y OTROS TIPOS DE ENSEÑANZA',
  '@i18n-quote-option-list-economicactivity3-option85': 'EMISORAS DE RADIO',
  '@i18n-quote-option-list-economicactivity3-option84': 'ELIMINACION DE AGUAS RESIDUALES; MANTENIMIENTO DE CLOACAS Y ALCA',
  '@i18n-quote-option-list-economicactivity3-option83': 'ELECTRICIDAD GAS Y AGUA',
  '@i18n-quote-option-list-economicactivity3-option82': 'ELABORACION PRODUCTOS DE CUERO EXCEPTO CALZADO (MALETAS, BOLSOS,',
  '@i18n-quote-option-list-economicactivity3-option81': 'ELABORACION DE PRODUCTOS LACTEOS (LECHE, MANTEQUILLAS, NATAS, QUESO, ETC.)',
  '@i18n-quote-option-list-economicactivity3-option80': 'ELABORACION DE PRODUCTOS DERIVADOS DE CEREALES (TRIGO, ARROZ, MAIZ)',
  '@i18n-quote-option-list-economicactivity3-option79': 'ELABORACION DE PRODUCTOS DE TABACO',
  '@i18n-quote-option-list-economicactivity3-option78': 'ELABORACION DE PRODUCTOS DE TABACO',
  '@i18n-quote-option-list-economicactivity3-option77': 'ELABORACION DE PRODUCTOS ALIMENTICIOS',
  '@i18n-quote-option-list-economicactivity3-option76': 'ELABORACION DE OTROS PRODUCTOS ALIMENTICIOS (CAFE, AZUCAR, PAN,',
  '@i18n-quote-option-list-economicactivity3-option75': 'ELABORACION DE BEBIDAS NO ALCOHOLICAS (AGUA MINERAL, REFRESCOS,',
  '@i18n-quote-option-list-economicactivity3-option74': 'ELABORACION DE BEBIDAS ALCOHOLICAS (RON, CERVEZA, WHISKY, VINOS)',
  '@i18n-quote-option-list-economicactivity3-option73': 'ELABORACION DE BEBIDAS',
  '@i18n-quote-option-list-economicactivity3-option72': 'DISQUERAS (VENTA DE DISCOS, CDS, SONIDO, DVD, AUDIO Y VIDEO)',
  '@i18n-quote-option-list-economicactivity3-option71': 'DIFUSION Y PROGRAMACION',
  '@i18n-quote-option-list-economicactivity3-option70': 'DEPOSITO Y ACTIVIDADES DE TRANSPORTE COMPLEMENTARIAS',
  '@i18n-quote-option-list-economicactivity3-option69': 'CULTIVOS DE PLANTAS PARA PRODUCTOS TEXTILES, CAÑA DE AZUCAR, CAFE',
  '@i18n-quote-option-list-economicactivity3-option68': 'CULTIVOS DE CEREALES Y OLEAGINOSAS',
  '@i18n-quote-option-list-economicactivity3-option67': 'CULTIVO DE PRODUCTOS AGRICOLAS EN COMBINACION CON LA CRIA DE ANIMALES',
  '@i18n-quote-option-list-economicactivity3-option66': 'CULTIVO DE HORTALIZAS, LEGUMBRES Y FRUTAS',
  '@i18n-quote-option-list-economicactivity3-option65': 'CRIA Y EXPLOTACION DE ANIMALES DOMESTICOS',
  '@i18n-quote-option-list-economicactivity3-option64': 'CRIA DE AVES, PRODUCCION DE HUEVOS Y LECHE',
  '@i18n-quote-option-list-economicactivity3-option63': 'CRIA DE ANIMALES DESTINADOS A LA PRODUCCION DE PIELES',
  '@i18n-quote-option-list-economicactivity3-option62': 'CORREOS PRIVADOS (COURIERS)',
  '@i18n-quote-option-list-economicactivity3-option61': 'CORREO Y SERVICIOS DE MENSAJERIA',
  '@i18n-quote-option-list-economicactivity3-option60': 'CORREDORES Y AGENTES DE SEGUROS; OTROS SERVICIOS RELACIONADOS CONEXOS',
  '@i18n-quote-option-list-economicactivity3-option59': 'CONSULTORES EN SISTEMAS Y PROGRAMAS DE INFORMATICA Y SUMINISTRO',
  '@i18n-quote-option-list-economicactivity3-option58': 'CONSULTORES EN EQUIPO DE INFORMATICA',
  '@i18n-quote-option-list-economicactivity3-option57': 'CONSTRUCCION Y REFORMA DE EDIFICIOS COMPLETOS O PARTES DE EDIFICIOS)',
  '@i18n-quote-option-list-economicactivity3-option56': 'CONSTRUCCION DE EDIFICIOS',
  '@i18n-quote-option-list-economicactivity3-option55': 'CONSTRUCCION DE CARRETERAS, DIQUES, PUENTES Y OBRAS AFINES',
  '@i18n-quote-option-list-economicactivity3-option54': 'CONSTRUCCION',
  '@i18n-quote-option-list-economicactivity3-option53': 'CONCESIONARIOS DE AUTOS / VENTA DE CARROS O MOTOCICLETAS',
  '@i18n-quote-option-list-economicactivity3-option52': 'COMPRA, VENTA, ALQUILER, VALUACION, ADMINISTRACION DE INMUEBLES',
  '@i18n-quote-option-list-economicactivity3-option51': 'COMERCIO AL POR MENOR, EXCEPTO EL COMERCIO DE VEHICULOS AUTOMOTORES  Y MOTOCICLETAS',
  '@i18n-quote-option-list-economicactivity3-option50': 'COMERCIO AL POR MAYOR, EXCEPTO DE LOS VEHICULOS DE MOTOR Y LAS MOTOCICLETAS',
  '@i18n-quote-option-list-economicactivity3-option49': 'COMERCIO AL POR MAYOR Y MENOR,RESTAURANTES Y HOTELES',
  '@i18n-quote-option-list-economicactivity3-option48': 'COMERCIO AL POR MAYOR Y AL POR MENOR REPARACION DE VEHICULOS AUTOMOTORES Y MOTOCICLETAS',
  '@i18n-quote-option-list-economicactivity3-option47': 'COMERCIALIZACION DE PRODUCTOS DE TABACO (CIGARRILLOS, CHIMO, ETC.)',
  '@i18n-quote-option-list-economicactivity3-option46': 'COMERCIALIZACION DE PRENDAS DE VESTIR (TELA Y CUERO)',
  '@i18n-quote-option-list-economicactivity3-option45': 'COMERCIALIZACION DE GRANOS, FRUTOS OLEAGINOSOS, FLORES, PLANTAS',
  '@i18n-quote-option-list-economicactivity3-option44': 'COMERCIALIZACION DE FRUTAS, VERDURAS Y HORTALIZAS FRESCAS',
  '@i18n-quote-option-list-economicactivity3-option43': 'COMERCIALIZACION DE EQUIPOS DE COMPUTACION O TELEFONIA Y AFINES',
  '@i18n-quote-option-list-economicactivity3-option42': 'COMERCIALIZACION DE ARTICULOS DEPORTIVOS, CAZA, PESCA',
  '@i18n-quote-option-list-economicactivity3-option41': 'CAZA ORDINARIA Y MEDIANTE TRAMPAS Y DE REPOBLACION',
  '@i18n-quote-option-list-economicactivity3-option40': 'CASAS DE BOLSA, SOCIEDAD DE CORRETAJE, SERVICIOS BURSATILES',
  '@i18n-quote-option-list-economicactivity3-option39': 'CAPTACION, TRATAMIENTO Y SUMINISTRO DE AGUA',
  '@i18n-quote-option-list-economicactivity3-option38': 'CAPTACION, DEPURACION Y DISTRIBUCION DE AGUA',
  '@i18n-quote-option-list-economicactivity3-option37': 'BIBLIOTECAS Y MUSEOS',
  '@i18n-quote-option-list-economicactivity3-option36': 'BANCOS COMERCIALES, HIPOTECARIOS, UNIVERSALES, ETC.',
  '@i18n-quote-option-list-economicactivity3-option35': 'AUTO MERCADOS, ABASTOS, BODEGAS, KIOSCOS',
  '@i18n-quote-option-list-economicactivity3-option34': 'ASERRADO Y ACEPILLADO DE MADERA',
  '@i18n-quote-option-list-economicactivity3-option33': 'ARRENDADORAS FINANCIERAS, ALMACENADORAS',
  '@i18n-quote-option-list-economicactivity3-option32': 'ALQUILER DE OTROS TIPOS DE MAQUINARIA Y EQUIPO',
  '@i18n-quote-option-list-economicactivity3-option31': 'ALQUILER DE EQUIPOS DE CONSTRUCCION Y DEMOLICION',
  '@i18n-quote-option-list-economicactivity3-option30': 'ALQUILER DE EQUIPO DE TRANSPORTE',
  '@i18n-quote-option-list-economicactivity3-option29': 'ALQUILER DE EFECTOS PERSONALES Y ENSERES DOMESTICOS',
  '@i18n-quote-option-list-economicactivity3-option28': 'ALOJAMIENTO (HOTELES, CASAS, CAMPAMENTOS Y OTROS)',
  '@i18n-quote-option-list-economicactivity3-option27': 'ALOJAMIENTO',
  '@i18n-quote-option-list-economicactivity3-option26': 'ALMACENAMIENTO Y DEPOSITO',
  '@i18n-quote-option-list-economicactivity3-option25': 'ALCANTARILLADO',
  '@i18n-quote-option-list-economicactivity3-option24': 'ALBAÑILERIA/HERRERIA/PLOMERIA/ELECTRICISTAS',
  '@i18n-quote-option-list-economicactivity3-option23': 'AGRICULTURA, PESCA Y GANADERIA',
  '@i18n-quote-option-list-economicactivity3-option22': 'AGRICULTURA, GANADERIA, CAZA Y ACTIVIDADES DE SERVICIO CONEXAS',
  '@i18n-quote-option-list-economicactivity3-option21': 'AGENTES ADUANALES',
  '@i18n-quote-option-list-economicactivity3-option20': 'AGENCIAS DE VIAJES',
  '@i18n-quote-option-list-economicactivity3-option19': 'AGENCIAS DE TRANSPORTE DE CARGA MARITIMO Y AEREO',
  '@i18n-quote-option-list-economicactivity3-option18': 'AGENCIAS DE LOTERIA, HIPODROMOS, CASINO SALAS DE LUDOPATIA.',
  '@i18n-quote-option-list-economicactivity3-option17': 'ADMINISTRACION PUBLICA Y DEFENSA',
  '@i18n-quote-option-list-economicactivity3-option16': 'ACTIVIDADES NO BIEN ESPECIFICADAS',
  '@i18n-quote-option-list-economicactivity3-option15': 'ACTIVIDADES JURIDICAS Y DE CONTABILIDAD',
  '@i18n-quote-option-list-economicactivity3-option14': 'ACTIVIDADES INMOBILIARIAS',
  '@i18n-quote-option-list-economicactivity3-option13': 'ACTIVIDADES ESPECIALIZADAS DE LA CONSTRUCCION',
  '@i18n-quote-option-list-economicactivity3-option12': 'ACTIVIDADES DEPORTIVAS PROFESIONALES. DEPORTISTAS.',
  '@i18n-quote-option-list-economicactivity3-option11': 'ACTIVIDADES DEL SERVICIO INFORMATIVO',
  '@i18n-quote-option-list-economicactivity3-option10': 'ACTIVIDADES DE SERVICIO RELACIONADAS CON LA EXTRACCION DE PETROLEO',
  '@i18n-quote-option-list-economicactivity3-option9': 'ACTIVIDADES DE SANEAMIENTO Y OTROS SERVICIOS DE GESTION DE DESECHOS',
  '@i18n-quote-option-list-economicactivity3-option8': 'ACTIVIDADES DE PUBLICACION',
  '@i18n-quote-option-list-economicactivity3-option7': 'ACTIVIDADES DE PRODUCCION DE PELICULAS, DE VIDEO DE PROGRAMAS DE TELEVISION, GRABACION Y PUBLICACION DE MUSICA Y SONIDO',
  '@i18n-quote-option-list-economicactivity3-option6': 'ACTIVIDADES DE OFICINAS CENTRALES (SOCIEDADES DE CARTERAS), ACTIVIDADES DE ADMINISTRACION DE EMPRESAS Y DE CONSULTORIA SOBRE ADMINISTRACION DE EMPRESAS',
  '@i18n-quote-option-list-economicactivity3-option5': 'ACTIVIDADES DE LA TECNOLOGIA DE INFORMACION Y DEL SERVICIO INFORMATIVO',
  '@i18n-quote-option-list-economicactivity3-option4': 'ACTIVIDADES DE IMPRESION Y REPRODUCCION DE GRABACIONES',
  '@i18n-quote-option-list-economicactivity3-option3': 'ACTIVIDADES DE  APOYO A LA EXPLOTACION DE MINAS',
  '@i18n-quote-option-list-economicactivity3-option2': 'ACONDICIONAMIENTO DE EDIFICIOS (CAÑERIAS, AIRE ACONDICIONADO, PLOMERIA, ETC.)',
  '@i18n-quote-option-list-economicactivity3-option1': 'ABOGADOS, JUECES, LEGISLADORES',


  '@i18n-quote-option-list-economicactivity2-option209': 'ZAPATERÍAS',
  '@i18n-quote-option-list-economicactivity2-option208': 'VETERINARIOS',
  '@i18n-quote-option-list-economicactivity2-option207': 'VENTA POR MAYOR Y MENOR DE BEBIDAS NO ALCOHÓLICAS Y AGUAS MINERA',
  '@i18n-quote-option-list-economicactivity2-option206': 'VENTA DE VEHÍCULOS AUTOMOTORES',
  '@i18n-quote-option-list-economicactivity2-option205': 'VENTA DE PARTES, PIEZAS Y ACCESORIOS DE VEHÍCULOS AUTOMOTORES.',
  '@i18n-quote-option-list-economicactivity2-option204': 'VENTA DE MOTOCICLETAS.',
  '@i18n-quote-option-list-economicactivity2-option203': 'VENTA DE GAS DE USO DOMÉSTICO E INDUSTRIAL',
  '@i18n-quote-option-list-economicactivity2-option202': 'VENTA DE COMIDA EN FERIAS, KIOSCOS, CANTINAS',
  '@i18n-quote-option-list-economicactivity2-option201': 'VENTA DE BEBIDAS ALCOHÓLICAS (DISTRIBUIDORA, LICORERÍAS)',
  '@i18n-quote-option-list-economicactivity2-option200': 'VENTA DE ABONOS, FERTILIZANTES, COMIDA PARA ANIMALES, PLAGUICIDA',
  '@i18n-quote-option-list-economicactivity2-option199': 'VENTA AL POR MENOR DE RELOJES, JOYAS Y ARTÍCULOS CONEXOS',
  '@i18n-quote-option-list-economicactivity2-option198': 'VENTA AL POR MENOR DE PLANTAS Y FLORES. FLORERÍAS',
  '@i18n-quote-option-list-economicactivity2-option197': 'VENTA AL POR MENOR DE COSMÉTICOS Y ARTÍCULOS DE TOCADOR (PERFUME',
  '@i18n-quote-option-list-economicactivity2-option196': 'VENTA AL POR MENOR DE ARTÍCULOS DE DECORACIÓN',
  '@i18n-quote-option-list-economicactivity2-option195': 'VENTA AL POR MAYOR DE PRODUCTOS ALIMENTICIOS ELABORADOS',
  '@i18n-quote-option-list-economicactivity2-option194': 'VENTA AL POR MAYOR DE OTROS PRODUCTOS',
  '@i18n-quote-option-list-economicactivity2-option193': 'VENTA AL POR MAYOR DE MAQUINARIA, EQUIPO Y MATERIALES',
  '@i18n-quote-option-list-economicactivity2-option192': 'VENTA AL POR MAYOR DE GANADO EN PIE (BOVINOS, OVINOS, EQUINOS, P',
  '@i18n-quote-option-list-economicactivity2-option191': 'VENTA AL POR MAYOR DE EQUIPO PARA RESTAURANTES, HOTELES, ETC.',
  '@i18n-quote-option-list-economicactivity2-option190': 'VENTA AL POR MAYOR DE ENSERES DOMÉSTICOS Y ARTÍCULOS DEL HOGAR.',
  '@i18n-quote-option-list-economicactivity2-option189': 'VENTA AL MAYOR Y DETAL DE PRODUCTOS DE LIMPIEZA E HIGIENE INDUSTRIAL Y/O HOGAR',
  '@i18n-quote-option-list-economicactivity2-option188': 'TRANSPORTE TERRESTRE URBANo EXTRAURBANO',
  '@i18n-quote-option-list-economicactivity2-option187': 'TRANSPORTE MARÍTIMO DE CARGA Y PASAJEROS',
  '@i18n-quote-option-list-economicactivity2-option186': 'TRANSPORTE FERROVIARIO DE CARGA Y PASAJEROS',
  '@i18n-quote-option-list-economicactivity2-option185': 'TRANSPORTE ESCOLAR / TURISMO',
  '@i18n-quote-option-list-economicactivity2-option184': 'TRANSPORTE DE VALORES, DOCUMENTACIÓN, ENCOMIENDA Y SIMILARES',
  '@i18n-quote-option-list-economicactivity2-option183': 'TRANSPORTE ALMACENAMIENTO Y COMUNICACIONES',
  '@i18n-quote-option-list-economicactivity2-option182': 'TRANSPORTE AÉREO DE CARGA Y PASAJEROS',
  '@i18n-quote-option-list-economicactivity2-option181': 'TERMINACIÓN DE EDIFICIOS (INCLUYE TERMINACIÓN Y ACABADO DE LA OBRAS)',
  '@i18n-quote-option-list-economicactivity2-option180': 'TELEVISORAS POR SEÑAL ABIERTA',
  '@i18n-quote-option-list-economicactivity2-option179': 'TELEVISIÓN POR CABLE O SATÉLITE',
  '@i18n-quote-option-list-economicactivity2-option178': 'TALLER DE REPARACIÓN, LIMPIEZA, LAVADO, PULIDO DE VEHÍCULOS / MOTOS',
  '@i18n-quote-option-list-economicactivity2-option177': 'SERVICIOS SOCIALES Y OTROS COMUNALES Y CONEXOS',
  '@i18n-quote-option-list-economicactivity2-option176': 'SERVICIOS SOCIALES Y OTROS COMUNALES NO CLASIFICADOS',
  '@i18n-quote-option-list-economicactivity2-option175': 'SERVICIOS RELACIONADOS CON EL TRANSPORTE NO CLASIFICADO EN OTRA',
  '@i18n-quote-option-list-economicactivity2-option174': 'SERVICIOS PERIODÍSTICOS PÚBLICOS Y PRIVADOS',
  '@i18n-quote-option-list-economicactivity2-option173': 'SERVICIOS MÉDICOS Y ODONTOLÓGICOS, OTROS SANIDAD',
  '@i18n-quote-option-list-economicactivity2-option172': 'SERVICIOS FUNERARIOS, CASAS DE SEPELIOS Y ACTIVIDADES CONEXAS.',
  '@i18n-quote-option-list-economicactivity2-option171': 'SERVICIOS DE TELECOMUNICACIONES NO ESPECIFICADAS EN OTRA PARTE',
  '@i18n-quote-option-list-economicactivity2-option170': 'SERVICIOS DE SANEAMIENTO Y SIMILARES',
  '@i18n-quote-option-list-economicactivity2-option169': 'SERVICIOS DE PRÁCTICAS DEPORTIVAS (INCLUYE CLUBES, GIMNASIOS)',
  '@i18n-quote-option-list-economicactivity2-option168': 'SERVICIOS DE MUDANZA / MANIPULACIÓN DE CARGAS',
  '@i18n-quote-option-list-economicactivity2-option167': 'SERVICIOS DE IMPRESIÓN, FOTOCOPIADO, CYBERG, ENCUADERNACIÓN Y C',
  '@i18n-quote-option-list-economicactivity2-option166': 'SERVICIOS DE FOTOGRAFÍA. ESTUDIOS Y LABORATORIOS FOTOGRÁFICOS. R',
  '@i18n-quote-option-list-economicactivity2-option165': 'SERVICIOS DE DIVERSIÓN Y ESPARCIMIENTO NO CLASIFICADOS',
  '@i18n-quote-option-list-economicactivity2-option164': 'SERVICIOS DE DIVERSIÓN DE ESPARCIMIENTO Y CULTURALES',
  '@i18n-quote-option-list-economicactivity2-option163': 'SERVICIOS DE CONTADURÍA, ADMINISTRADORAS',
  '@i18n-quote-option-list-economicactivity2-option162': 'SERVICIOS DE ASOC. COMERCIALES, PROFESIONALES Y LABORALES (COOPERATIVAS)',
  '@i18n-quote-option-list-economicactivity2-option161': 'SERVICIOS DE ASISTENCIA SOCIAL (AMBULANCIAS, LABORATORIOS)',
  '@i18n-quote-option-list-economicactivity2-option160': 'SERVICIOS CINEMATOGRÁFICOS, RADIO Y TELEVISIÓN, TEATRO Y MÚSICA',
  '@i18n-quote-option-list-economicactivity2-option159': 'SERVICIOS AGROPECUARIOS (FUMIGACIÓN, RECOLECCIÓN Y ALQUILER DE M',
  '@i18n-quote-option-list-economicactivity2-option158': 'SERVICIO, COMUNALES, SOCIALES Y PERSONALES',
  '@i18n-quote-option-list-economicactivity2-option157': 'SERVICIO DOMÉSTICO, AMA DE LLAVES, CHOFER',
  '@i18n-quote-option-list-economicactivity2-option156': 'SERVICIO DE TRANSPORTE PRIVADO (TAXI, MOTO TAXI, EXCURSIÓN, VIAJE)',
  '@i18n-quote-option-list-economicactivity2-option155': 'SERVICIO DE TELEFONÍA FIJA Y CELULAR',
  '@i18n-quote-option-list-economicactivity2-option154': 'SEGUROS',
  '@i18n-quote-option-list-economicactivity2-option153': 'SALONES DE BAILE, DISCOTECAS Y SIMILARES',
  '@i18n-quote-option-list-economicactivity2-option152': 'RESTAURANTES Y CAFÉS',
  '@i18n-quote-option-list-economicactivity2-option151': 'REPARACIÓN E INSTALACIÓN DE LA MAQUINARIA Y EQUIPO',
  '@i18n-quote-option-list-economicactivity2-option150': 'REPARACIÓN DE ARTEFACTOS ELÉCTRICOS',
  '@i18n-quote-option-list-economicactivity2-option149': 'REFINERÍAS DE PETRÓLEO',
  '@i18n-quote-option-list-economicactivity2-option148': 'RECICLAMIENTO (MATERIAL U ORGÁNICO)',
  '@i18n-quote-option-list-economicactivity2-option147': 'PRODUCCIÓN Y PROCESAMIENTO DE CARNES Y PESCADO',
  '@i18n-quote-option-list-economicactivity2-option146': 'PRODUCCIÓN Y PROCESAMIENTO DE  FRUTAS, LEGUMBRES, HORTALIZAS, ETC.',
  '@i18n-quote-option-list-economicactivity2-option145': 'PRODUCCIÓN DE PETRÓLEO CRUDO Y GAS NATURAL',
  '@i18n-quote-option-list-economicactivity2-option144': 'PRODUCCIÓN DE ESPECTÁCULOS DEPORTIVOS',
  '@i18n-quote-option-list-economicactivity2-option143': 'PROCESAMIENTO DE DATOS',
  '@i18n-quote-option-list-economicactivity2-option142': 'PREPARACIÓN DEL TERRENO',
  '@i18n-quote-option-list-economicactivity2-option141': 'PIZZERÍA, COMIDA RÁPIDA (FRANQUICIA), HELADERÍAS',
  '@i18n-quote-option-list-economicactivity2-option140': 'PESCA MARÍTIMA (DE ALTURA Y COSTERA).',
  '@i18n-quote-option-list-economicactivity2-option139': 'PESCA FLUVIAL Y LACUSTRE (CONTINENTAL).',
  '@i18n-quote-option-list-economicactivity2-option138': 'PELUQUERÍA Y OTROS TRATAMIENTOS DE BELLEZA.',
  '@i18n-quote-option-list-economicactivity2-option137': 'PANADERÍAS, CAFETERÍAS, CHARCUTERÍAS, PASTELERÍAS',
  '@i18n-quote-option-list-economicactivity2-option136': 'OTROS TIPOS DE VENTAS AL POR MENOR EN ALMACENES ESPECIALIZADOS',
  '@i18n-quote-option-list-economicactivity2-option135': 'OTROS TIPOS DE TRANSPORTE REGULAR DE CARGA POR VÍA TERRESTRE',
  '@i18n-quote-option-list-economicactivity2-option134': 'OTROS RELACIONADOS A LA CONSTRUCCIÓN',
  '@i18n-quote-option-list-economicactivity2-option133': 'OTROS ELECTRICIDAD GAS AGUA',
  '@i18n-quote-option-list-economicactivity2-option132': 'OTROS COMERCIOS',
  '@i18n-quote-option-list-economicactivity2-option131': 'OTRAS ACTIVIDADES VINCULADAS A MINAS E HIDROCARBUROS',
  '@i18n-quote-option-list-economicactivity2-option130': 'OTRAS ACTIVIDADES FINANCIERAS',
  '@i18n-quote-option-list-economicactivity2-option129': 'OTRAS ACTIVIDADES DE SERVICIOS PERSONALES Y DEL HOGAR.',
  '@i18n-quote-option-list-economicactivity2-option128': 'OTRAS ACTIVIDADES DE SANEAMIENTO.',
  '@i18n-quote-option-list-economicactivity2-option127': 'OTRAS ACTIVIDADES DE INFORMÁTICA.',
  '@i18n-quote-option-list-economicactivity2-option126': 'OTRAS ACTIVIDADES DE AGRICULTURA, PESCA Y GANADERÍA',
  '@i18n-quote-option-list-economicactivity2-option125': 'ÓPTICAS',
  '@i18n-quote-option-list-economicactivity2-option124': 'MÚSICO, CANTANTE, ARTISTA',
  '@i18n-quote-option-list-economicactivity2-option123': 'MUEBLERÍAS',
  '@i18n-quote-option-list-economicactivity2-option122': 'MINAS E HIDROCARBUROS',
  '@i18n-quote-option-list-economicactivity2-option121': 'MICROEMPRESARIO (VENTA AL POR MENOR EN PUESTOS DE VENTA Y EN MERCADOS)',
  '@i18n-quote-option-list-economicactivity2-option120': 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS AUTOMOTORES.',
  '@i18n-quote-option-list-economicactivity2-option119': 'MANTENIMIENTO Y REPARACIÓN DE MOTOCICLETAS.',
  '@i18n-quote-option-list-economicactivity2-option118': 'MANTENIMIENTO Y REPARACIÓN DE MAQUINARIA DE OFICINA, CONTABILIDAD',
  '@i18n-quote-option-list-economicactivity2-option117': 'LIMPIEZA URBANA Y RECOLECCIÓN DE RESIDUOS',
  '@i18n-quote-option-list-economicactivity2-option116': 'LIBRERÍAS, PAPELERÍAS, VENTA DE MATERIALES DE OFICINA',
  '@i18n-quote-option-list-economicactivity2-option115': 'LAVADO, LIMPIEZA Y TEÑIDO DE PRENDAS DE TELA O DE PIEL.',
  '@i18n-quote-option-list-economicactivity2-option114': 'JUGUETERÍAS',
  '@i18n-quote-option-list-economicactivity2-option113': 'JUEGOS DE SALÓN (BINGO, BILLAR, POOL, BOWLING, JUEGOS ELECTRÓNICOS)',
  '@i18n-quote-option-list-economicactivity2-option112': 'INSTRUCCIÓN Y ENSEÑANZA (BÁSICA Y SUPERIOR)',
  '@i18n-quote-option-list-economicactivity2-option111': 'INDUSTRIAS MANUFACTURERAS',
  '@i18n-quote-option-list-economicactivity2-option110': 'IMPRENTAS, EDITORIALES O INDUSTRIAS CONEXAS',
  '@i18n-quote-option-list-economicactivity2-option109': 'GRANDES TIENDAS Y ALMACENES. TIENDAS Y ALMACENES MINORISTAS POR',
  '@i18n-quote-option-list-economicactivity2-option108': 'GENERACIÓN, CAPTACIÓN Y DISTRIBUCIÓN DE ENERGÍA ELÉCTRICA',
  '@i18n-quote-option-list-economicactivity2-option107': 'GASOLINERAS / ESTACIONES DE SUMINISTROS DE GASOLINA Y DIÉSEL',
  '@i18n-quote-option-list-economicactivity2-option106': 'GALERÍAS DE ARTE; CASAS DE ANTIGÜEDADES',
  '@i18n-quote-option-list-economicactivity2-option105': 'FUNDICIÓN DE METALES',
  '@i18n-quote-option-list-economicactivity2-option104': 'FUMIGACIÓN, DESINFECCIÓN, EXTERMINIO DE INSECTOS Y PLAGAS',
  '@i18n-quote-option-list-economicactivity2-option103': 'FRIGORÍFICOS, CARNICERÍA, PESCADERÍA',
  '@i18n-quote-option-list-economicactivity2-option102': 'FORESTACIÓN (PLANTACIÓN, REPOBLACIÓN, CONSERVACIÓN DE BOSQUES Y',
  '@i18n-quote-option-list-economicactivity2-option101': 'FINANCIERAS,SEGUROS,INMUEBLES,SERV.TEC Y PROF Y',
  '@i18n-quote-option-list-economicactivity2-option100': 'FERRETERÍAS Y MATERIALES DE CONSTRUCCIÓN Y PINTURA (ARENA, BLOQUES)',
  '@i18n-quote-option-list-economicactivity2-option99': 'FARMACIAS, DROGUERÍAS Y CASAS NATURISTAS',
  '@i18n-quote-option-list-economicactivity2-option98': 'FABRICACIÓN Y ENSAMBLADO DE VEHÍCULOS AUTOMOTORES.',
  '@i18n-quote-option-list-economicactivity2-option97': 'FABRICACIÓN DE VIDRIO Y PRODUCTOS DE VIDRIO',
  '@i18n-quote-option-list-economicactivity2-option96': 'FABRICACIÓN DE TEXTILES (TELAS, ALFOMBRAS, LENCERÍA, CORTINAS)',
  '@i18n-quote-option-list-economicactivity2-option95': 'FABRICACIÓN DE SUSTANCIAS QUÍMICAS E INDUSTRIALES',
  '@i18n-quote-option-list-economicactivity2-option94': 'FABRICACIÓN DE PRODUCTOS QUÍMICOS NO CLASIFICADOS EN OTRA PARTE',
  '@i18n-quote-option-list-economicactivity2-option93': 'FABRICACIÓN DE PRODUCTOS PRIMARIOS DE HIERRO Y ACERO.',
  '@i18n-quote-option-list-economicactivity2-option92': 'FABRICACIÓN DE PRODUCTOS NO CLASIFICADOS',
  '@i18n-quote-option-list-economicactivity2-option91': 'FABRICACIÓN DE PRODUCTOS METÁLICOS, MAQUINARIAS Y EQUIPOS',
  '@i18n-quote-option-list-economicactivity2-option90': 'FABRICACIÓN DE PRODUCTOS METÁLICOS, EXCEPTO MAQUINARIAS Y EQUIPO',
  '@i18n-quote-option-list-economicactivity2-option89': 'FABRICACIÓN DE PRODUCTOS FARMACÉUTICOS, SUSTANCIAS QUÍMICAS MEDICAS',
  '@i18n-quote-option-list-economicactivity2-option88': 'FABRICACIÓN DE PRODUCTOS DE PLÁSTICO',
  '@i18n-quote-option-list-economicactivity2-option87': 'FABRICACIÓN DE PRODUCTOS DE MADERA, CORCHO, PAJA Y MATERIALES TR',
  '@i18n-quote-option-list-economicactivity2-option86': 'FABRICACIÓN DE PRODUCTOS DE CAUCHO',
  '@i18n-quote-option-list-economicactivity2-option85': 'FABRICACIÓN DE PRENDAS DE VESTIR',
  '@i18n-quote-option-list-economicactivity2-option84': 'FABRICACIÓN DE PINTURAS, BARNICES Y PRODUCTOS DE REVESTIMIENTO S',
  '@i18n-quote-option-list-economicactivity2-option83': 'FABRICACIÓN DE PARTES Y REPUESTOS PARA VEHÍCULOS AUTOMOTORES',
  '@i18n-quote-option-list-economicactivity2-option82': 'FABRICACIÓN DE PAPEL, CARTÓN Y SUS DERIVADOS',
  '@i18n-quote-option-list-economicactivity2-option81': 'FABRICACIÓN DE OTROS TIPO DE EQUIPO DE TRANSPORTE (BARCOS, TRENES)',
  '@i18n-quote-option-list-economicactivity2-option80': 'FABRICACIÓN DE MUEBLES DE HOGAR Y DE OFICINA',
  '@i18n-quote-option-list-economicactivity2-option79': 'FABRICACIÓN DE MAQUINARIA Y APARATOS ELÉCTRICOS (MOTORES, LÁMPARAS)',
  '@i18n-quote-option-list-economicactivity2-option78': 'FABRICACIÓN DE MAQUINARIA DE OFICINA, CONTABILIDAD E INFORMÁTICA',
  '@i18n-quote-option-list-economicactivity2-option77': 'FABRICACIÓN DE INSTRUMENTOS Y EQUIPOS MÉDICOS',
  '@i18n-quote-option-list-economicactivity2-option76': 'FABRICACIÓN DE GAS; DISTRIBUCIÓN DE COMBUSTIBLES GASEOSOS',
  '@i18n-quote-option-list-economicactivity2-option75': 'FABRICACIÓN DE EQUIPOS DE TV, AUDIO, VIDEO Y COMUNICACIONES',
  '@i18n-quote-option-list-economicactivity2-option74': 'FABRICACIÓN DE EQUIPO PROFESIONAL Y CIENTÍFICO',
  '@i18n-quote-option-list-economicactivity2-option73': 'FABRICACIÓN DE CERÁMICAS, ARENAS , BALDOSAS, CAL, YESO, CONCRETO',
  '@i18n-quote-option-list-economicactivity2-option72': 'FABRICACIÓN DE CALZADO (VESTIR Y DEPORTIVO)',
  '@i18n-quote-option-list-economicactivity2-option71': 'FABRICACIÓN DE APARATOS DE USO DOMÉSTICO',
  '@i18n-quote-option-list-economicactivity2-option70': 'FAB.SUST.QUIMICAS Y PROD. QUÍMICOS DERIVADOS DEL PETRÓLEO',
  '@i18n-quote-option-list-economicactivity2-option69': 'EXTRACCIÓN DE OTROS MINERALES',
  '@i18n-quote-option-list-economicactivity2-option68': 'EXTRACCIÓN DE MINERALES METÁLICOS',
  '@i18n-quote-option-list-economicactivity2-option67': 'EXTRACCIÓN DE MADERA. CORTE, DESBASTE DE TRONCO Y MADERA EN BRUTO',
  '@i18n-quote-option-list-economicactivity2-option66': 'EXPLOTACIÓN DE OTRAS MINAS O CANTERAS',
  '@i18n-quote-option-list-economicactivity2-option65': 'EXPLOTACIÓN DE MINAS DE CARBÓN',
  '@i18n-quote-option-list-economicactivity2-option64': 'EXPLOTACIÓN DE CRIADEROS O VIVEROS DE PECES Y OTROS FRUTOS ACUÁTICOS',
  '@i18n-quote-option-list-economicactivity2-option63': 'EXPLOTACIÓN DE BOSQUES SIN REPLANTACIÓN',
  '@i18n-quote-option-list-economicactivity2-option62': 'ESTACIONAMIENTOS; GARAJES',
  '@i18n-quote-option-list-economicactivity2-option61': 'ENSEÑANZA TÉCNICA Y OTROS TIPOS DE ENSEÑANZA',
  '@i18n-quote-option-list-economicactivity2-option60': 'EMISORAS DE RADIO',
  '@i18n-quote-option-list-economicactivity2-option59': 'ELIMINACIÓN DE AGUAS RESIDUALES; MANTENIMIENTO DE CLOACAS Y ALCA',
  '@i18n-quote-option-list-economicactivity2-option58': 'ELECTRICIDAD GAS Y AGUA',
  '@i18n-quote-option-list-economicactivity2-option57': 'ELABORACIÓN PRODUCTOS DE CUERO EXCEPTO CALZADO (MALETAS, BOLSOS,',
  '@i18n-quote-option-list-economicactivity2-option56': 'ELABORACIÓN DE PRODUCTOS LÁCTEOS (LECHE, MANTEQUILLAS, NATAS, QUESO, ETC.)',
  '@i18n-quote-option-list-economicactivity2-option55': 'ELABORACIÓN DE PRODUCTOS DERIVADOS DE CEREALES (TRIGO, ARROZ, MAÍZ)',
  '@i18n-quote-option-list-economicactivity2-option54': 'ELABORACIÓN DE PRODUCTOS DE TABACO',
  '@i18n-quote-option-list-economicactivity2-option53': 'ELABORACIÓN DE OTROS PRODUCTOS ALIMENTICIOS (CAFÉ, AZÚCAR, PAN,',
  '@i18n-quote-option-list-economicactivity2-option52': 'ELABORACIÓN DE BEBIDAS NO ALCOHÓLICAS (AGUA MINERAL, REFRESCOS,',
  '@i18n-quote-option-list-economicactivity2-option51': 'ELABORACIÓN DE BEBIDAS ALCOHÓLICAS (RON, CERVEZA, WHISKY, VINOS)',
  '@i18n-quote-option-list-economicactivity2-option50': 'DISQUERAS (VENTA DE DISCOS, CDS, SONIDO, DVD, AUDIO Y VIDEO)',
  '@i18n-quote-option-list-economicactivity2-option49': 'CULTIVOS DE PLANTAS PARA PRODUCTOS TEXTILES, CAÑA DE AZÚCAR, CAFÉ',
  '@i18n-quote-option-list-economicactivity2-option48': 'CULTIVOS DE CEREALES Y OLEAGINOSAS',
  '@i18n-quote-option-list-economicactivity2-option47': 'CULTIVO DE PRODUCTOS AGRÍCOLAS EN COMBINACIÓN CON LA CRÍA DE ANIMALES',
  '@i18n-quote-option-list-economicactivity2-option46': 'CULTIVO DE HORTALIZAS, LEGUMBRES Y FRUTAS',
  '@i18n-quote-option-list-economicactivity2-option45': 'CRÍA Y EXPLOTACIÓN DE ANIMALES DOMÉSTICOS',
  '@i18n-quote-option-list-economicactivity2-option44': 'CRIA DE AVES, PRODUCCIÓN DE HUEVOS Y LECHE',
  '@i18n-quote-option-list-economicactivity2-option43': 'CRIA DE ANIMALES DESTINADOS A LA PRODUCCIÓN DE PIELES',
  '@i18n-quote-option-list-economicactivity2-option42': 'CORREOS PRIVADOS (COURIERS)',
  '@i18n-quote-option-list-economicactivity2-option41': 'CORREDORES Y AGENTES DE SEGUROS; OTROS SERVICIOS RELACIONADOS CONEXOS',
  '@i18n-quote-option-list-economicactivity2-option40': 'CONSULTORES EN SISTEMAS Y PROGRAMAS DE INFORMÁTICA Y SUMINISTRO',
  '@i18n-quote-option-list-economicactivity2-option39': 'CONSULTORES EN EQUIPO DE INFORMÁTICA',
  '@i18n-quote-option-list-economicactivity2-option38': 'CONSTRUCCIÓN Y REFORMA DE EDIFICIOS COMPLETOS O PARTES DE EDIFICIOS)',
  '@i18n-quote-option-list-economicactivity2-option37': 'CONSTRUCCIÓN DE CARRETERAS, DIQUES, PUENTES Y OBRAS AFINES',
  '@i18n-quote-option-list-economicactivity2-option36': 'CONSTRUCCION',
  '@i18n-quote-option-list-economicactivity2-option35': 'CONCESIONARIOS DE AUTOS / VENTA DE CARROS O MOTOCICLETAS',
  '@i18n-quote-option-list-economicactivity2-option34': 'COMPRA, VENTA, ALQUILER, VALUACIÓN, ADMINISTRACIÓN DE INMUEBLES',
  '@i18n-quote-option-list-economicactivity2-option33': 'COMERCIO AL POR MAYOR Y MENOR,RESTAURANTES Y HOTELES',
  '@i18n-quote-option-list-economicactivity2-option32': 'COMERCIALIZACIÓN DE PRODUCTOS DE TABACO (CIGARRILLOS, CHIMO, ETC.)',
  '@i18n-quote-option-list-economicactivity2-option31': 'COMERCIALIZACIÓN DE PRENDAS DE VESTIR (TELA Y CUERO)',
  '@i18n-quote-option-list-economicactivity2-option30': 'COMERCIALIZACIÓN DE GRANOS, FRUTOS OLEAGINOSOS, FLORES, PLANTAS',
  '@i18n-quote-option-list-economicactivity2-option29': 'COMERCIALIZACIÓN DE FRUTAS, VERDURAS Y HORTALIZAS FRESCAS',
  '@i18n-quote-option-list-economicactivity2-option28': 'COMERCIALIZACIÓN DE EQUIPOS DE COMPUTACIÓN O TELEFONÍA Y AFINES',
  '@i18n-quote-option-list-economicactivity2-option27': 'COMERCIALIZACIÓN DE ARTÍCULOS DEPORTIVOS, CAZA, PESCA',
  '@i18n-quote-option-list-economicactivity2-option26': 'CAZA ORDINARIA Y MEDIANTE TRAMPAS Y DE REPOBLACIÓN',
  '@i18n-quote-option-list-economicactivity2-option25': 'CASAS DE BOLSA, SOCIEDAD DE CORRETAJE, SERVICIOS BURSÁTILES',
  '@i18n-quote-option-list-economicactivity2-option24': 'CAPTACIÓN, DEPURACIÓN Y DISTRIBUCIÓN DE AGUA',
  '@i18n-quote-option-list-economicactivity2-option23': 'BIBLIOTECAS Y MUSEOS',
  '@i18n-quote-option-list-economicactivity2-option22': 'BANCOS COMERCIALES, HIPOTECARIOS, UNIVERSALES, ETC.',
  '@i18n-quote-option-list-economicactivity2-option21': 'AUTO MERCADOS, ABASTOS, BODEGAS, KIOSCOS',
  '@i18n-quote-option-list-economicactivity2-option20': 'ASERRADO Y ACEPILLADO DE MADERA',
  '@i18n-quote-option-list-economicactivity2-option19': 'ARRENDADORAS FINANCIERAS, ALMACENADORAS',
  '@i18n-quote-option-list-economicactivity2-option18': 'ALQUILER DE OTROS TIPOS DE MAQUINARIA Y EQUIPO',
  '@i18n-quote-option-list-economicactivity2-option17': 'ALQUILER DE EQUIPOS DE CONSTRUCCIÓN Y DEMOLICIÓN',
  '@i18n-quote-option-list-economicactivity2-option16': 'ALQUILER DE EQUIPO DE TRANSPORTE',
  '@i18n-quote-option-list-economicactivity2-option15': 'ALQUILER DE EFECTOS PERSONALES Y ENSERES DOMÉSTICOS',
  '@i18n-quote-option-list-economicactivity2-option14': 'ALOJAMIENTO (HOTELES, CASAS, CAMPAMENTOS Y OTROS)',
  '@i18n-quote-option-list-economicactivity2-option13': 'ALMACENAMIENTO Y DEPÓSITO',
  '@i18n-quote-option-list-economicactivity2-option12': 'ALBAÑILERÍA/HERRERÍA/PLOMERÍA/ELECTRICISTAS',
  '@i18n-quote-option-list-economicactivity2-option11': 'AGRICULTURA, PESCA Y GANADERIA',
  '@i18n-quote-option-list-economicactivity2-option10': 'AGENTES ADUANALES',
  '@i18n-quote-option-list-economicactivity2-option9': 'AGENCIAS DE VIAJES',
  '@i18n-quote-option-list-economicactivity2-option8': 'AGENCIAS DE TRANSPORTE DE CARGA MARÍTIMO Y AÉREO',
  '@i18n-quote-option-list-economicactivity2-option7': 'AGENCIAS DE LOTERÍA, HIPÓDROMOS, CASINO SALAS DE LUDOPATÍA.',
  '@i18n-quote-option-list-economicactivity2-option6': 'ADMINISTRACIÓN PÚBLICA Y DEFENSA',
  '@i18n-quote-option-list-economicactivity2-option5': 'ACTIVIDADES NO BIEN ESPECIFICADAS',
  '@i18n-quote-option-list-economicactivity2-option4': 'ACTIVIDADES DEPORTIVAS PROFESIONALES. DEPORTISTAS.',
  '@i18n-quote-option-list-economicactivity2-option3': 'ACTIVIDADES DE SERVICIO RELACIONADAS CON LA EXTRACCIÓN DE PETRÓLEO',
  '@i18n-quote-option-list-economicactivity2-option2': 'ACONDICIONAMIENTO DE EDIFICIOS (CAÑERÍAS, AIRE ACONDICIONADO, PLOMERÍA, ETC.)',
  '@i18n-quote-option-list-economicactivity2-option1': 'ABOGADOS, JUECES, LEGISLADORES',
  '@i18n-quote-option-list-destinationOfFunds-option9': 'SOLICITUD DE CRÉDITO',
  '@i18n-quote-option-list-destinationOfFunds-option8': 'RECIBIR O ENVIAR TRANSFERENCIAS A OTROS BANCOS',
  '@i18n-quote-option-list-destinationOfFunds-option7': 'PERSONAL',
  '@i18n-quote-option-list-destinationOfFunds-option6': 'PAGO DE SERVICIOS',
  '@i18n-quote-option-list-destinationOfFunds-option5': 'NÓMINA',
  '@i18n-quote-option-list-destinationOfFunds-option4': 'FIDEICOMISO',
  '@i18n-quote-option-list-destinationOfFunds-option3': 'EMISIÓN DE CHEQUES DE GERENCIA',
  '@i18n-quote-option-list-destinationOfFunds-option2': 'COMPRA DE MONEDA VIRTUAL',
  '@i18n-quote-option-list-destinationOfFunds-option1': 'AHORRO',
  '@i18n-quote-option-list-currency-bs': 'Bs',
  '@i18n-quote-option-list-condition-option3': 'Cuentadante',
  '@i18n-quote-option-list-condition-option2': 'Autorizado',
  '@i18n-quote-option-list-condition-option1': 'Representante Legal',
  '@i18n-quote-option-list-boolean-option-true': 'Sí',
  '@i18n-quote-option-list-boolean-option-false': 'No',
  '@i18n-quote-option-list-applicantType-option-natural': ' Persona Natural',
  '@i18n-quote-option-list-applicantType-option-legal': 'Persona Jurídica',
  '@i18n-quote-option-list-accountType-savings': 'Cuenta de Ahorro',
  '@i18n-quote-option-list-accountType-checking': 'Cuenta Corriente',
  '@i18n-quote-marketInformation-section.title': 'Información Económica Financiera',
  '@i18n-quote-marketInformation-marketInformationFields-section.title': '',
  '@i18n-quote-marketInformation-form-label-totalMonthlyIncome': 'Ingresos mensuales ',
  '@i18n-quote-marketInformation-form-label-totalMonthlyExpenses': 'Total Egresos Mensuales',
  '@i18n-quote-marketInformation-form-label-numberOfEmployees': 'Número de Empleados',
  '@i18n-quote-marketInformation-form-label-numberOfBranches': 'N° de subsidiarias/oficinas',
  '@i18n-quote-marketInformation-form-label-countryWithTheGreatestPresence': 'País con Mayor Presencia',
  '@i18n-quote-marketInformation-ISRLDeclaration-section.title':
  `  
  <div class="text-secondary font-weight-normal alert alert-warning p-3 mt-4 mb-4 animate__animated animate__fadeIn fz-14 ">
       <span >En caso de empresas con una antigüedad mayor a un año indique el año y monto neto pagado según la última declaración de impuestos sobre la renta (ISLR).  En caso de empresas recientemente formadas puede continuar sin este apartado.
       </span>
 </div>

  Última Declaración de ISLR

  `,
  '@i18n-quote-legalRepresentative-pep-form-label-relationshipType': 'Tipo de Relación',
  '@i18n-quote-legalRepresentative-pep-form-label-position': 'Cargo',
  '@i18n-quote-legalRepresentative-pep-form-label-country': 'País',
  '@i18n-quote-legalRepresentative-modal-section-title': 'Representante (s) Legal (es) / Autorizado (s) a Movilizar la Cuenta',
  '@i18n-quote-legalRepresentative-form-label-typeIdentity': 'Documento de Identidad',
  '@i18n-quote-legalRepresentative-form-label-secondName': 'Segundo nombre',
  '@i18n-quote-legalRepresentative-form-label-secondLastName': 'Segundo apellido',
  '@i18n-quote-legalRepresentative-form-label-position': 'Cargo',
  '@i18n-quote-legalRepresentative-form-label-occupation': 'Teléfono',
  '@i18n-quote-legalRepresentative-form-label-nauionality': 'Nacionalidad',
  '@i18n-quote-legalRepresentative-form-label-identity': 'Número de Documento',
  '@i18n-quote-legalRepresentative-form-label-firstName': 'Primer nombre',
  '@i18n-quote-legalRepresentative-form-label-firstLastName': 'Primer apellido',
  '@i18n-quote-legalRepresentative-form-label-condition': 'Condición',
  '@i18n-quote-form-label-termsAndConditions': `Al registrarme acepto los <a  class='{"rxOption":"showTermAndoConditions"} text-primary'> Términos y Condiciones del servicio</a>`,
  '@i18n-quote-footer-text-standard': '{clientNameShort}, utiliza estándares de encriptación y la información es confidencialmente almacenada. ',
  '@i18n-quote-footer-more-information': 'Más información visite. ',
  '@i18n-quote-fiscalAddress-section.title': 'Direcciones',
  '@i18n-quote-fiscalAddress-form-label-urbanization': 'Parroquia / Urbanización',
  '@i18n-quote-fiscalAddress-form-label-street': 'Avenida / Calle',
  '@i18n-quote-fiscalAddress-form-label-state': 'Estado',
  '@i18n-quote-fiscalAddress-form-label-postalCode': 'Código Postal',
  '@i18n-quote-fiscalAddress-form-label-office': 'Apartamento / Oficina',
  '@i18n-quote-fiscalAddress-form-label-municipality': 'Municipio',
  '@i18n-quote-fiscalAddress-form-label-floor': 'Número / Piso',
  '@i18n-quote-fiscalAddress-form-label-country': 'País',
  '@i18n-quote-fiscalAddress-form-label-city': 'Ciudad',
  '@i18n-quote-fiscalAddress-form-label-buildingName': 'Nombre del Edif / Casa / Galpón / Local',
  '@i18n-quote-economicInformation-section.title': 'Información Económica',
  '@i18n-quote-economicInformation-economicInformationFields-section.title': '',
  '@i18n-quote-economicActivity-section.title': 'Actividad Económica',
  '@i18n-quote-economicActivity-form-label-specialCategory': 'Categoría Especial',
  '@i18n-quote-economicActivity-form-label-especificActivity': 'Actividad Específica',
  '@i18n-quote-economicActivity-form-label-economicActivity': 'Actividad Económica',
  '@i18n-quote-customers-section.title': 'Principales Clientes',
  '@i18n-quote-customers-modal-section-title': 'Principales Clientes',
    '@i18n-quote-createUser-form-label-userName': 'Nombre de usuario',
  '@i18n-quote-createUser-form-label-password': 'Contraseña',
  '@i18n-quote-createUser-form-label-name': 'Primer Nombre',
  '@i18n-quote-createUser-form-label-lastName': 'Primer Apellido',
  '@i18n-quote-createUser-form-label-email': 'Correo electrónico',
  '@i18n-quote-createUser-form-label-country-natural': 'País de Residencia',
  '@i18n-quote-createUser-form-label-country-legal': 'País donde opera',
  '@i18n-quote-createUser-form-label-confirmPassword': 'Confirmación de Contraseña',
  '@i18n-quote-createUser-form-label-businessName': 'Nombre de la Razón Social',
  '@i18n-quote-createUser-form-label-applicantType': 'Tipo de Solicitante',
  '@i18n-quote-createUser-companyName-section-title': '',
  '@i18n-quote-createUser-companyName-section-description': 'En los datos personales, registre los datos del usuario que será administrador de la cuenta. ',
  '@i18n-quote-createUser-applicantType-section-description': '',
  '@i18n-quote-contactMeans-section.title': 'Medios de Contacto',
  '@i18n-quote-contactMeans-form-label-website': 'Sitio Web, Blog, y/o Redes Sociales',
  '@i18n-quote-contactMeans-form-label-otherPhone': 'Otro Teléfono',
  '@i18n-quote-contactMeans-form-label-mainPhone': 'Teléfono Principal',
  '@i18n-quote-contactMeans-form-label-email': 'Correo electrónico',
  '@i18n-quote-constitutionData-section.title': 'Datos de Constitución',
  '@i18n-quote-constitutionData-form-label-tomo': 'Tomo',
  '@i18n-quote-constitutionData-form-label-socialCapital': 'Capital Social (Actual)',
  '@i18n-quote-constitutionData-form-label-registryNumber': 'Número',
  '@i18n-quote-constitutionData-form-label-registryName': 'Nombre del Registro',
  '@i18n-quote-constitutionData-form-label-registryDate': 'Fecha',
  '@i18n-quote-constitutionData-form-label-folio': 'Folio',
  '@i18n-quote-calculator-form-button-quotingApply': 'Aplicar',
  '@i18n-quote-businessData-section.title': 'Datos Basicos',
  '@i18n-quote-businessData-form-label-tradename': 'Nombre Comercial',
  '@i18n-quote-businessData-form-label-taxId': 'Número de Identificación Fiscal',
  '@i18n-quote-businessData-form-label-legalForm': 'Forma Jurídica',
  '@i18n-quote-businessData-form-label-businessName': 'Nombre de la Razón Social',
  '@i18n-quote-boardOfDirectors-section.title': 'Junta Directiva',
  '@i18n-quote-boardOfDirectors-pep-modal-section-title': 'Persona Políticamente Expuesta',
  '@i18n-quote-boardOfDirectors-modal-section-title': 'Miembro Junta Directiva',
  '@i18n-quote-boardOfDirectors-boardOfDirectorsTable-section.title': 'Miembros de la Junta Directiva',
  '@i18n-quote-bankAccountsWithOtherInstitutions-section.title': 'Cuentas Bancarias',
  '@i18n-quote-bankAccountsWithOtherInstitutions-bankAccountsWithOtherInstitutionsTable-section.title': '',
  '@i18n-quote-bankAccountsWithOtherInstitutions-bankAccountsWithOtherInstitutionsCheck-section.title': '',
  '@i18n-quote-bankAccountsWithInstitution-section.title': 'Referencias bancarias con la institución',
  '@i18n-quote-bankAccountsWithInstitution-bankAccountsWithInstitutionTable-section.title': '',
  '@i18n-quote-bankAccountsWithInstitution-bankAccountsWithInstitutionCheck-section.title': '',
  '@i18n-quote-bankAccount-form-label-bank': 'Institución Bancaria',
  '@i18n-quote-bankAccount-form-label-averageDigit': 'Cifras Promedio',
  '@i18n-quote-bankAccount-form-label-accountType': 'Tipo de Cuenta',
  '@i18n-quote-bankAccount-form-label-accountNumber': 'Número de Cuenta',
  '@i18n-quote-accreditedRecord-form-label-personalTaxID': 'Cédula de Identidad',
  '@i18n-quote-accreditedRecord-form-label-passport': 'Pasaporte',
  '@i18n-quote-accreditedRecord-form-label-identity': 'Cédula de Identidad',
  '@i18n-quote-account-contract-declaration': '',
  '@i18n-quote-ISRLDeclaration-form-label-year': 'Año',
  '@i18n-quote-ISRLDeclaration-form-label-amount': 'Monto Neto Pagado',
  '@i18n-products-and-services': 'Conoce nuestros productos y servicios',
  '@i18n-product-information-account-opening-step-name': 'Perfil de Inversión',
  '@i18n-plans-text-waranty-default': 'A satisfacción del banco',
  '@i18n-plans-text-initial-default': 'Sin inicial requerida',
  '@i18n-plans-text-conditions': ' Requisitos',
  '@i18n-plans-text-apply': 'Aplicar',
  '@i18n-plans-label-waranty': 'Garantía',
  '@i18n-plans-label-terms': 'Plazos',
  '@i18n-plans-label-rate': 'Tasa',
  '@i18n-plans-label-initial': 'Inicial',
  '@i18n-plans-label-flatcomission': 'Comisión Flat',
  '@i18n-plans-label-financeAmount': 'Montos a financiar',
  '@i18n-plans-global-text-until': 'Hasta',
  '@i18n-plans-description': 'Beneficios',
  '@i18n-personal-information-account-opening-step-name': 'Identificación del Cliente',
  '@i18n-open-account-title': 'Apertura de Cuenta',
  '@i18n-open-account-subtitle': 'Su cuenta para lo que quieras.',
  '@i18n-menu-label-exit': 'Salir',
  '@i18n-menu-label-client-home': 'Principal',
  '@i18n-market-information-account-opening-step-name': 'Información Económica Financiera',
  '@i18n-mail-verify-account': 'Verificar',
  '@i18n-list-account-opening-step-name': '',
  '@i18n-form-pattern-password': 'Debe contener: Entre 8 y 12 caracteres, números, minúsculas, mayúsculas y caracteres especiales.<br>          No debe contener: Más de 3 caracteres consecutivos iguales (alfabéticos, numéricos o especiales).',
  '@i18n-form-button-sectionSave2': ' <i class="mr-2  fas fa-save"></i> Guardar',
  '@i18n-form-button-sectionSave': ' <i class="mr-2  fas fa-save"></i> Guardar',

  '@i18n-form-button-add': 'Agregar',
  '@i18n-economic-information-account-opening-step-name': 'Información Financiera ',
  '@i18n-constitution-data-account-opening-step-name2': '',
  '@i18n-constitution-data-account-opening-step-name': 'Datos de Constitución y Actividad Económica',
  '@i18n-confirmation-are-you-shure-delete-pep': 'Se eliminarán todas las personas políticamente expuestas',
  '@i18n-confirmation-are-you-shure': '¿Está seguro(a)?',
  '@i18n-comments-product-information-account-opening-step-name': 'Comentarios',
  '@i18n-comments-client-identificaction-account-opening-step-name': 'Comentarios',
  '@i18n-business-identity-account-opening-step-name': 'Identificación de la Empresa',
  '@i18n-app-column-update-date': 'Última actualización',

  '18n-quote-accreditedRecord-form-label-identity': 'Número de Documento',

  '@i18n-form-pattern-user': 'El nombre de usuario debe tener solo números y letras minúsculas',



  '@i18n-summary-account-opening-step-upload-file': 'Recaudos',
  '@i18n-menu-label-client-doc-support': 'Recaudos',


  '@i18n-menu-label-client-inbox-m': 'BANDEJA DE ENTRADA',
  '@i18n-menu-label-client-sent-m': 'ENVIADOS',
  '@i18n-menu-label-client-draft-m': 'BORRADOR',
  '@i18n-compleat': 'Completar',
  '@i18n-workflow-name-accountopening': 'Datos de la Solicitud',
  '@i18n-workflow-name-docsupport': 'Recaudos',
  '@i18n-new-user-question': 'Nuevo?',
  "@i18n-change-password": "Cambiar Contraseña",




  ' --------------- ---:': "PN -----------------------------------------------",

  '@i18n-quote-relatedPerson-form-label-firstLastName': 'Apellido',

  '@i18n-quote-pn-form-label-firstLastName': 'Primer Apellido',
  '@i18n-quote-pn-form-label-secondLastName': 'Segundo Apellido',
  '@i18n-quote-pn-form-label-firstName': 'Primer nombre',
  '@i18n-quote-pn-form-label-secondName': 'Segundo Nombre',
  '@i18n-quote-pn-form-label-typeIdentity': 'Documento de Identidad',
  '@i18n-quote-pn-form-label-identity': 'Número de Documento',
    '@i18n-quote-pn-form-label-birthDate':   `
  <div class="text-secondary font-weight-normal alert alert-warning p-3 mt-4 mb-4 animate__animated animate__fadeIn ">
                                 <span >En caso de ser menor de edad debe estar cedulado y registrar a su representante legal</span>
 </div>
 
  <div>Fecha</div>
   
  `,
  '@i18n-quote-pn-form-label-nacionality': 'Nacionalidad',
  '@i18n-quote-pn-form-label-state': 'Estado',
  '@i18n-quote-pn-form-label-city': 'Ciudad',
  '@i18n-quote-pn-form-label-occupation': 'Profesión u Oficio',
  '@i18n-quote-pn-form-label-familyBurden': 'Carga Familiar',
  '@i18n-quote-spouse-form-label-firstLastName': 'Primer Apellido',
  '@i18n-quote-spouse-form-label-secondLastName': 'Segundo Apellido',
  '@i18n-quote-spouse-form-label-firstName': 'Primer nombre',
  '@i18n-quote-spouse-form-label-secondName': 'Segundo Nombre',
  '@i18n-quote-spouse-form-label-typeIdentity': 'Documento de Identidad',
  '@i18n-quote-spouse-form-label-identity': 'Número de Documento',
  '@i18n-quote-spouse-form-label-sourceOfIncome': 'Fuente de Ingresos',
  '@i18n-quote-homeAddress-form-label-state': 'Estado',
  '@i18n-quote-homeAddress-form-label-city': 'Ciudad',
  '@i18n-quote-homeAddress-form-label-municipality': 'Municipio',
  '@i18n-quote-homeAddress-form-label-urbanization': 'Parroquia / Urbanización',
  '@i18n-quote-homeAddress-form-label-postalCode': 'Código Postal',
  '@i18n-quote-homeAddress-form-label-street': 'Avenida / Calle',
  '@i18n-quote-homeAddress-form-label-buildingName': 'Nombre del Edif / Casa / Galpón / Local',
  '@i18n-quote-homeAddress-form-label-floor': 'Número / Piso',
  '@i18n-quote-homeAddress-form-label-referencePoint': 'Apartamento / Oficina',
  '@i18n-quote-homeAddress-form-label-housingCondition': 'Condición de la vivienda',
  '@i18n-quote-pn-contactMeans-form-label-mainPhone': ' Teléfono Celular',
  '@i18n-quote-pn-contactMeans-form-label-homePhone': 'Otro Teléfono',
  '@i18n-quote-pn-contactMeans-form-label-email': 'Email',
  '@i18n-quote-pn-contactMeans-form-label-website': 'Sitio Web, Blog, y/o Redes Sociales',
  '@i18n-quote-legalRepresentative-form-label-state': 'Estado',
  '@i18n-quote-legalRepresentative-form-label-city': 'Ciudad',
  '@i18n-quote-legalRepresentative-form-label-birthDate': 'Fecha de Nacimiento',
  '@i18n-quote-legalRepresentative-form-label-dataAttorneyDocument': 'Datos del Documento del Poder Notariado',
  '@i18n-quote-relationOfLaborDependency-form-label-businessName': 'Nombre de la Empresa',
  '@i18n-quote-relationOfLaborDependency-form-label-taxId': 'Número de Identificación Fiscal',
  '@i18n-quote-relationOfLaborDependency-form-label-dateOfAdmission': 'Fecha de Ingreso',
  '@i18n-quote-relationOfLaborDependency-pep-form-label-position': 'Cargo que Ocupa',
  '@i18n-quote-relationOfLaborDependency-pep-form-label-businessBranch': 'Ramo del Negocio',
  '@i18n-quote-ownBusiness-form-label-businessName': 'Nombre de la Empresa',
  '@i18n-quote-ownBusiness-form-label-taxId': 'Número de Identificación Fiscal',
  '@i18n-quote-ownBusiness-form-label-income': 'Ingresos',
  '@i18n-quote-ownBusiness-pep-form-label-businessBranch': 'Ramo del Negocio',
  '@i18n-quote-fiscalAddress-form-label-referencePoint': 'Apartamento / Oficina',
  '@i18n-quote-relatedPerson-form-label-legalForm': 'Forma Jurídica',
  '@i18n-quote-anotherSourceIncome-form-label-incomeGeneratingActivity': 'Actividad Generadora de los Ingresos',
  '@i18n-quote-anotherSourceIncome-form-label-monthlyIncome': 'Ingresos Mensuales',
  '@i18n-quote-relatedPerson-form-label-secondLastName': 'Segundo Apellido',
  '@i18n-quote-relatedPerson-form-label-nacionality': 'Nacionalidad',
  '@i18n-quote-relatedPerson-form-label-typeIdentity': 'Documento de Identidad',
  '@i18n-quote-relatedPerson-form-label-identity': 'Número de Documento',
  '@i18n-quote-relatedPerson-form-label-homePhone': 'Otro Teléfono',
  '@i18n-quote-relatedPerson-form-label-mainPhone': 'Teléfono Celular',

  '@i18n-quote-homeAddress-section.title': 'Dirección de Domicilio',
  '@i18n-quote-contactMeansPN-section.title': 'Medios de Contacto',

  '@i18n-quote-option-list-gender-female': 'Femenino',
  '@i18n-quote-option-list-gender-male': 'Masculino',



  "@i18n-quote-legalRepresentativePN-checkLegalRepresentative-section.title": "",

  '@i18n-personal-references-account-opening-step-name': 'Referencias Personales',
  '@i18n-quote-pn-form-label-nationality': 'Nacionalidad ',
  '@i18n-quote-pn-form-label-other-nacionality': 'Otra Nacionalidad',
  '@i18n-quote-pn-form-label-other-nationality': "Otra Nacionalidad",
  '@i18n-quote-economicActivityPN-section.title': 'Actividad Económica',


  '@i18n-quote-anotherSourceIncome-section.title': 'Otras Fuentes de Ingresos',
  '@i18n-quote-suppliersPN-suppliersPNTable-section.title': 'Principales Proveedores',
  '@i18n-quote-suppliersPN-section-description': '',
  '@i18n-quote-customersPN-customersPNTable-section.title': 'Principales Clientes',
  '@i18n-quote-customersPN-section-description': '',
  '@i18n-quote-personalReferences-personalReferencesTable-section.title': '',
  '@i18n-quote-personalReferences-section.title': 'Referencias Personales',
  '@i18n-quote-PersonalReferences-section.title': 'Referencias Personales',
  '@i18n-quote-relatedPerson-form-label-nationality': 'Nacionalidad',


  "@i18n-quote-accreditedRecord-form-label-civilStatus-option-single": "Soltero (a)",
  "@i18n-quote-accreditedRecord-form-label-civilStatus-option-married": "Casado (a)",
  "@i18n-quote-accreditedRecord-form-label-civilStatus-option-divorced": "Divorciado (a)",
  "@i18n-quote-accreditedRecord-form-label-civilStatus-option-widower": "Viudo (a)",
  "@i18n-quote-accreditedRecord-form-label-dependent-option-depend": "Dependiente",
  "@i18n-quote-accreditedRecord-form-label-dependent-option-noDepend": "No dependiente",
  "@i18n-quote-accreditedRecord-form-label-dependent-option-pencionado": "Pencionado",
  "@i18n-quote-accreditedRecord-form-label-dependent-option-other": "Otro",
  "@i18n-quote-option-list-housingCondition-option-1": "Adjudicada",
  "@i18n-quote-option-list-housingCondition-option-2": "Alquilada",
  "@i18n-quote-option-list-housingCondition-option-3": "De Familiares",
  "@i18n-quote-option-list-housingCondition-option-4": "Hipotecada",
  "@i18n-quote-option-list-housingCondition-option-5": "Propia",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-1": "Arrendamiento de bienes, muebles e inmuebles",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-2": "Beca",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-3": "Docencia",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-4": "Economía Informal",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-5": "Intermediario de Seguros",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-6": "Operario de transporte público y privado",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-7": "Prestamista",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-8": "Rifas,loterías y otros sorteos",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-9": "Ingresos a través de terceros",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-10": "Remesas Familiares",
  "@i18n-quote-option-list-incomeGeneratingActivity-option-11": "Servicios profesionales y técnicos",
  '@i18n-quote-relatedPerson-form-label-personContact': 'Persona de Contacto',

  '@i18n-section-title-PERSONAL_INFORMATION_SPOUSE': 'Datos del Cónyuge',
  '@i18n-section-title-RELATION_OF_LABOR_DEPENDENCY_FISCAL_ADDRESS': 'Direcciones',
  '@i18n-section-title-RELATION_OF_LABOR_DEPENDENCY_CONTACT_MEANS': 'Medios de Contacto',
  '@i18n-section-title-OWN_BUSINESS_ADDRESS': 'Direcciones',
  '@i18n-section-title-OWN_BUSINESS_CONTACT_MEANS': 'Medios de Contacto',
  '@i18n-section-title-OWN_BUSINESS_REGISTRY_DATA': 'Datos de Registro',

  "@i18n-quote-legalRepresentative-pep-form-label-isNotRelatedToPep": "Declaro que la persona no posee Parentesco con PEP",

  "@i18n-legalRepresentative-section.sub-title": 'Representante(s) Legal(es) o Autorizado(s) a Movilizar la Cuenta',
  "@i18n-related-persons-section.sub-title": 'Parentesco con PEP',
  "@i18n-suppliers-section.sub-title": 'Principales Clientes',
  "@i18n-customers-section.sub-title": 'Principales Proveedores',
  "@i18n-personalReferences-section.sub-title": 'Referencias Personales ',

  ' --------------- -----:': "Fin PN -----------------------------------------------",

  '@i18n-text-products-1': '',
  '@i18n-text-products-2': 
  `

     
<div>
<div class="w-100  d-none d-md-block" >
        <img class="w-100 animate__animated animate__fadeIn animate__slower" src="./assets/public/images/banner_acme_bank_ppal_desktop.png" alt="">

</div>

<div class="w-100  d-md-none "  >
        <img class="w-100 animate__animated animate__fadeIn " src="./assets/public/images/banner_acme_bank_ppal_mobile.png" alt="">
</div>

</div>

<div class=" container-lg mt-5 mb-4">

        <div class=' mt-3 text-dark'>
            <div class='list d-flex bd-highlight justify-content-center text-center  list-flex flex-wrap'>
                <div class='bd-highlight  w-100 order-1  '>
                    <h2 class='font-weight-normal '>Disfruta de tu nueva relación con el banco</h2>
                </div>
            </div>
        </div>

<div class="w-100 pt-3 d-none d-md-block">
    <img class="w-100 animate__animated animate__fadeIn animate__slower" src="./assets/public/images/banner_solicitud_desktop.png" alt="">

</div>

<div class="w-100 pt-3 d-md-none ">
        <img class="w-100 animate__animated animate__fadeIn " src="./assets/public/images/banner_solicitud_mobile.png" alt="">
</div>

</div>

</div>
  
  `,



  ' ----------- ---:': "product diseño apartir de aqui -----------------------------------------------",

  '@i18n-product-long-description-product1-1': '<div class="fz-14" ><b>Cuenta de Corretaje Bursátil</b></div><div class="fz-14 text-secondary mt-2" >Obtenga su Cuenta de Corretaje Bursátil</div>',
  
  ' ----------- ----:': "product diseño hast de aqui -----------------------------------------------",


  '@i18n-text-plan-1': '<div class=\' mt-3 text-dark\'><div class=\'list d-flex bd-highlight justify-content-center text-center  list-flex flex-wrap\'><div class=\'bd-highlight  w-100 order-1  \'><h2 class=\'font-weight-normal \'> Disfruta de tu nueva relación con el banco</h2></div></div></div>',
  '@i18n-text-plan-2': '',


  ' ----------- ------:': "planes diseño apartir de aqui -----------------------------------------------",


  '@i18n-plan-short-description-plan1': 'Cuenta Corriente',
  '@i18n-plan-subtittle-plan1': 'Solicita una cuenta corriente en Bs.',
  '@i18n-plan-long-description-plan1': '',
  "@i18n-plan-notes-plan1":  `
  No te precupes puedes iniciar tu solitud e ir completando a tu conveniencia.
    <br> <br> 
     <a href='security/login' class='text-primary'>Accede a una solicitud ya en progreso</a> `,


  '@i18n-plan-short-description-plan2': 'Custodia de Divisas',
  '@i18n-plan-subtittle-plan2': 'Solicita una cuenta corriente en USD & EUR',
  '@i18n-plan-long-description-plan2': '',
  "@i18n-plan-notes-plan2":  `
  No te precupes puedes iniciar tu solitud e ir completando a tu conveniencia.
    <br> <br> 
     <a href='security/login' class='text-primary'>Accede a una solicitud ya en progreso</a> `,



  '@i18n-plan-short-description-plan3': 'Cuenta de Ahorro',
  '@i18n-plan-subtittle-plan3': 'Solicita una cuenta corriente en Bs.',
  '@i18n-plan-long-description-plan3':'',
  "@i18n-plan-notes-plan3":  `
  No te precupes puedes iniciar tu solitud e ir completando a tu conveniencia.
    <br> <br> 
     <a href='security/login' class='text-primary'>Accede a una solicitud ya en progreso</a> `,

  

  ' ------------ ---:': "planes diseño apartir de aqui -----------------------------------------------",

  ' -------------- ---:': "fin nuevo diseño apartir de aqui -----------------------------------------------",

  '@i18n-quote-relatedPerson-form-label-otherPhone': 'Otro Teléfono',
  '@i18n-quote-relatedPerson-form-label-address': 'Dirección',

  '@i18n-quote-productInformation-form-label-planName': 'Tipo',
  'document support': 'Recaudos',

  '@i18n-quote-option-list-occupation-option-1': 'AMA DE CASA',
  '@i18n-quote-option-list-occupation-option-2': 'AMA DE LLAVES MAYORDOMO DOMESTICA',
  '@i18n-quote-option-list-occupation-option-3': 'ANALISTA DE OFICINA',
  '@i18n-quote-option-list-occupation-option-4': 'ANIMADOR',
  '@i18n-quote-option-list-occupation-option-5': 'ANTICUARIO COLECCIONISTA',
  '@i18n-quote-option-list-occupation-option-6': 'ANTROPOLOGIA, SOCIOLOGIA Y TRABAJO SOCIAL',
  '@i18n-quote-option-list-occupation-option-7': 'ARBITRO DEPORTIVO',
  '@i18n-quote-option-list-occupation-option-8': 'ARCHIVISTA',
  '@i18n-quote-option-list-occupation-option-9': 'ARCHIVOLOGIA Y BIBLIOTECOLOGIA',
  '@i18n-quote-option-list-occupation-option-10': 'ARQUITECTURA AERONAUTICA Y CIENCIAS NAOTICAS',
  '@i18n-quote-option-list-occupation-option-11': 'AQUITECTURA Y URBANISMO',
  '@i18n-quote-option-list-occupation-option-12': 'ARTES Y MUSICA',
  '@i18n-quote-option-list-occupation-option-13': 'ARTES, LETRAS Y SIMILARES',
  '@i18n-quote-option-list-occupation-option-14': 'ARTESANO',
  '@i18n-quote-option-list-occupation-option-15': 'ARTISTA',
  '@i18n-quote-option-list-occupation-option-16': 'ARTISTA DE CIRCO',
  '@i18n-quote-option-list-occupation-option-17': 'ASCENSORISTA',
  '@i18n-quote-option-list-occupation-option-18': 'ASEADOR',
  '@i18n-quote-option-list-occupation-option-19': 'ASERRADOR',
  '@i18n-quote-option-list-occupation-option-20': 'ASESOR CONSULTOR',
  '@i18n-quote-option-list-occupation-option-21': 'ASISTENTE',
  '@i18n-quote-option-list-occupation-option-22': 'AZAFATA ASISTENTE DE ABORDO',
  '@i18n-quote-option-list-occupation-option-23': 'BAILARIN',
  '@i18n-quote-option-list-occupation-option-24': 'BARBERO',
  '@i18n-quote-option-list-occupation-option-25': 'BARMAN',
  '@i18n-quote-option-list-occupation-option-26': 'BIBLIOTECARIOS',
  '@i18n-quote-option-list-occupation-option-27': 'BIOANALISIS',
  '@i18n-quote-option-list-occupation-option-28': 'BIOLOGIA',
  '@i18n-quote-option-list-occupation-option-29': 'BIOLOGIA MARINA Y CIENCIAS APLICADAS AL MAR',
  '@i18n-quote-option-list-occupation-option-30': 'BOMBERO',
  '@i18n-quote-option-list-occupation-option-31': 'BUZO',
  '@i18n-quote-option-list-occupation-option-32': 'CADDY',
  '@i18n-quote-option-list-occupation-option-33': 'CAJERO',
  '@i18n-quote-option-list-occupation-option-34': 'CALETERO',
  '@i18n-quote-option-list-occupation-option-35': 'CAMARERO',
  '@i18n-quote-option-list-occupation-option-36': 'CAMAROGRAFO',
  '@i18n-quote-option-list-occupation-option-37': 'CAMBISTA',
  '@i18n-quote-option-list-occupation-option-38': 'CAMILLERO',
  '@i18n-quote-option-list-occupation-option-39': 'CANTANTE',
  '@i18n-quote-option-list-occupation-option-40': 'CANTINERO',
  '@i18n-quote-option-list-occupation-option-41': 'CARPINTERO',
  '@i18n-quote-option-list-occupation-option-42': 'CARTERO',
  '@i18n-quote-option-list-occupation-option-43': 'CARTOGRAFO',
  '@i18n-quote-option-list-occupation-option-44': 'CATADOR',
  '@i18n-quote-option-list-occupation-option-45': 'CAUCHERO',
  '@i18n-quote-option-list-occupation-option-46': 'CAZADOR',
  '@i18n-quote-option-list-occupation-option-47': 'CERRAJERO',
  '@i18n-quote-option-list-occupation-option-48': 'CIENCIAS ADMINISTRATIVAS GERENCIALES',
  '@i18n-quote-option-list-occupation-option-49': 'CIENCIAS ADMINISTRATIVAS Y FINANCIERAS FISCALES Y RENTAS',
  '@i18n-quote-option-list-occupation-option-50': 'CIENCIAS BASICAS ',
  '@i18n-quote-option-list-occupation-option-51': 'CIENCIAS DE LA SALUD',
  '@i18n-quote-option-list-occupation-option-52': 'CIENCIAS DEL AGRO Y DEL MAR, RECURSOS NATURALES',
  '@i18n-quote-option-list-occupation-option-53': 'CIENCIAS FISCALES Y FINANCIERAS',
  '@i18n-quote-option-list-occupation-option-54': 'CIENCIAS MECANICAS, ELECTRICA Y ELECTRONICAS',
  '@i18n-quote-option-list-occupation-option-55': 'CIENCIAS NAVALES',
  '@i18n-quote-option-list-occupation-option-56': 'CIENCIAS POLICIALES',
  '@i18n-quote-option-list-occupation-option-57': 'CIENCIAS SOCIALES Y SIMILARES',
  '@i18n-quote-option-list-occupation-option-58': 'CIENCIAS Y ARTES MILITARES',
  '@i18n-quote-option-list-occupation-option-59': 'COBRADOR',
  '@i18n-quote-option-list-occupation-option-60': 'COCINERO CHEF',
  '@i18n-quote-option-list-occupation-option-61': 'COMERCIANTE DE CHATARRA Y METALES',
  '@i18n-quote-option-list-occupation-option-62': 'COMERCIANTE INDEPENDIENTE (BUHONERO, COMISIONISTA, VENDEDOR AMBULANTE, COMERCIANTE)',
  '@i18n-quote-option-list-occupation-option-63': 'COMPOSITOR',
  '@i18n-quote-option-list-occupation-option-64': 'COMPUTISTA PROGRAMADOR',
  '@i18n-quote-option-list-occupation-option-65': 'COMUNICACIÓN SOCIAL',
  '@i18n-quote-option-list-occupation-option-66': 'CONDUCTOR (CHOFER, TAXISTA, GANDOLERO)',
  '@i18n-quote-option-list-occupation-option-67': 'CONSERJE',
  '@i18n-quote-option-list-occupation-option-68': 'CONSTRUCCION Y DISEÑO DE OBRAS CIVILES',
  '@i18n-quote-option-list-occupation-option-69': 'CONSTRUCTOR',
  '@i18n-quote-option-list-occupation-option-70': 'CONTABLE',
  '@i18n-quote-option-list-occupation-option-71': 'CONTADURIA',
  '@i18n-quote-option-list-occupation-option-72': 'CONTRATISTA',
  '@i18n-quote-option-list-occupation-option-73': 'COREOGRAFO',
  '@i18n-quote-option-list-occupation-option-74': 'CORREDOR',
  '@i18n-quote-option-list-occupation-option-75': 'CORREDOR DE SEGUROS',
  '@i18n-quote-option-list-occupation-option-76': 'COSMETOLOGO',
  '@i18n-quote-option-list-occupation-option-77': 'COSTURERO',
  '@i18n-quote-option-list-occupation-option-78': 'CREATIVO',
  '@i18n-quote-option-list-occupation-option-79': 'CRISTALERO',
  '@i18n-quote-option-list-occupation-option-80': 'CUIDADOR NIÑERO',
  '@i18n-quote-option-list-occupation-option-81': 'DECORADOR',
  '@i18n-quote-option-list-occupation-option-82': 'DEPORTISTA (ATLETA)',
  '@i18n-quote-option-list-occupation-option-83': 'DERECHO',
  '@i18n-quote-option-list-occupation-option-84': 'DESEMPLEADO',
  '@i18n-quote-option-list-occupation-option-85': 'DETECTIVE INVESTIGADOR',
  '@i18n-quote-option-list-occupation-option-86': 'DIBUJANTE',
  '@i18n-quote-option-list-occupation-option-87': 'DIRECTOR',
  '@i18n-quote-option-list-occupation-option-88': 'DISEÑADOR',
  '@i18n-quote-option-list-occupation-option-89': 'DISKJOCKEY',
  '@i18n-quote-option-list-occupation-option-90': 'DOCENTE (PROFESOR MAESTRO)',
  '@i18n-quote-option-list-occupation-option-91': 'EBANISTA',
  '@i18n-quote-option-list-occupation-option-92': 'ECONOMIA',
  '@i18n-quote-option-list-occupation-option-93': 'EDUCACION AGROPECUARIA',
  '@i18n-quote-option-list-occupation-option-94': 'EDUCACION EN CASTELLANO Y LITERATURA, IDIOMAS Y LENGUAS EXTRANJERAS',
  '@i18n-quote-option-list-occupation-option-95': 'EDUCACION EN CIENCIAS BASICAS',
  '@i18n-quote-option-list-occupation-option-96': 'EDUCACION EN CIENCIAS SOCIALES',
  '@i18n-quote-option-list-occupation-option-97': 'EDUCACION ESPECIAL',
  '@i18n-quote-option-list-occupation-option-98': 'EDUCACION FISICA',
  '@i18n-quote-option-list-occupation-option-99': 'EDUCACION PEDAGOGICA Y PREESCOLAR',
  '@i18n-quote-option-list-occupation-option-100': 'EDUCACION TECNICA INDUSTRIAL Y COMERCIAL',
  '@i18n-quote-option-list-occupation-option-101': 'EDUCACION Y PEDAGOGIA',
  '@i18n-quote-option-list-occupation-option-102': 'ELECTRICISTA',
  '@i18n-quote-option-list-occupation-option-103': 'EMPLEADO DE OFICINA O NEGOCIO',
  '@i18n-quote-option-list-occupation-option-104': 'ENCUESTADOR',
  '@i18n-quote-option-list-occupation-option-105': 'ENFERMERIA',
  '@i18n-quote-option-list-occupation-option-106': 'ENFERMERO',
  '@i18n-quote-option-list-occupation-option-107': 'ENTRENADOR DEPORTIVO',
  '@i18n-quote-option-list-occupation-option-108': 'ESCENOGRAFO',
  '@i18n-quote-option-list-occupation-option-109': 'ESCRITO',
  '@i18n-quote-option-list-occupation-option-110': 'ESCULTOR TALLADOR',
  '@i18n-quote-option-list-occupation-option-111': 'ESOTERICO BRUJO VIDENTE ASTROLOGO ESPIRITISTA',
  '@i18n-quote-option-list-occupation-option-112': 'ESTADISTICA Y CIENCIAS ACTUARIALES',
  '@i18n-quote-option-list-occupation-option-113': 'ESTILISTA',
  '@i18n-quote-option-list-occupation-option-114': 'ESTUDIANTE',
  '@i18n-quote-option-list-occupation-option-115': 'ESTUDIOS INTERNACIONALES',
  '@i18n-quote-option-list-occupation-option-116': 'ESTUDIOS POLITICOS',
  '@i18n-quote-option-list-occupation-option-117': 'EXPLORACION Y EXPLOTACION DE MINAS, PETROLEO E HIDROCARBUROS',
  '@i18n-quote-option-list-occupation-option-118': 'EXPLOSIVISTA',
  '@i18n-quote-option-list-occupation-option-119': 'FARMACIA',
  '@i18n-quote-option-list-occupation-option-120': 'FILOSOFIA Y TEOLOGIA',
  '@i18n-quote-option-list-occupation-option-121': 'FISCAL DE TRANSITO',
  '@i18n-quote-option-list-occupation-option-122': 'FISICA',
  '@i18n-quote-option-list-occupation-option-123': 'FLORISTERO',
  '@i18n-quote-option-list-occupation-option-124': 'FOTOGRAFO',
  '@i18n-quote-option-list-occupation-option-125': 'FUMIGADOR',
  '@i18n-quote-option-list-occupation-option-126': 'FUNCIONARIO EXTRANJERO (EMBAJADA, CONSULADO)',
  '@i18n-quote-option-list-occupation-option-127': 'FUNCIONARIO PUBLICO',
  '@i18n-quote-option-list-occupation-option-128': 'FUNCIONARIO PUBLICO DE ELECCION POPULAR',
  '@i18n-quote-option-list-occupation-option-129': 'GEOGRAFIA',
  '@i18n-quote-option-list-occupation-option-130': 'GERENTE',
  '@i18n-quote-option-list-occupation-option-131': 'GESTOR',
  '@i18n-quote-option-list-occupation-option-132': 'GRANITERO',
  '@i18n-quote-option-list-occupation-option-133': 'GUARDAPARQUES GUARDABOSQUES',
  '@i18n-quote-option-list-occupation-option-134': 'GUIA TURISTICO',
  '@i18n-quote-option-list-occupation-option-135': 'HERRERO',
  '@i18n-quote-option-list-occupation-option-136': 'HERRERO, FORJADOR',
  '@i18n-quote-option-list-occupation-option-137': 'HISTORIA',
  '@i18n-quote-option-list-occupation-option-138': 'IDIOMAS MODERNOS',
  '@i18n-quote-option-list-occupation-option-139': 'INFORMATICA, SISTEMAS Y COMPUTACION',
  '@i18n-quote-option-list-occupation-option-140': 'INGENIERIA AGRONOMICA , AGRICOLA, AGROINDUSTRIAL Y DE PRODUCCION',
  '@i18n-quote-option-list-occupation-option-141': 'INGENIERIA CIVIL Y SIMILARES',
  '@i18n-quote-option-list-occupation-option-142': 'INGENIERIA DE ALIMENTOS',
  '@i18n-quote-option-list-occupation-option-143': 'INGENIERIA DE SISTEMAS, COMPUTACION E INFORMATICA',
  '@i18n-quote-option-list-occupation-option-144': 'INGENIERIA EN RECURSOS NATURALES RENOVABLES Y FORESTAL',
  '@i18n-quote-option-list-occupation-option-145': 'INGENIERIA GEOLOGICA, GEOFISICA E HIDROMETEREOLOGICA',
  '@i18n-quote-option-list-occupation-option-146': 'INGENIERIA MECANICA, ELECTRICA Y ELECTRONICA',
  '@i18n-quote-option-list-occupation-option-147': 'INGENIERIA PETROLERA, MINAS E HIDROCARBUROS',
  '@i18n-quote-option-list-occupation-option-148': 'INGENIERIA QUIMICA E INDUSTRIALES',
  '@i18n-quote-option-list-occupation-option-149': 'INSPECTOR DE SINIESTRO',
  '@i18n-quote-option-list-occupation-option-150': 'INSTRUCTOR (DE MANEJO, DE ALGUN OFICIO)',
  '@i18n-quote-option-list-occupation-option-151': 'INTERPRETE',
  '@i18n-quote-option-list-occupation-option-152': 'JARDINERO',
  '@i18n-quote-option-list-occupation-option-153': 'JEFE',
  '@i18n-quote-option-list-occupation-option-154': 'JINETE',
  '@i18n-quote-option-list-occupation-option-155': 'JOYERO ORFEBRE',
  '@i18n-quote-option-list-occupation-option-156': 'JUBILADO PENSIONADO',
  '@i18n-quote-option-list-occupation-option-157': 'LABORATORISTA (TECNICO)',
  '@i18n-quote-option-list-occupation-option-158': 'LAVANDERO LIMPIADOR PLANCHADOR',
  '@i18n-quote-option-list-occupation-option-159': 'LEÑADOR',
  '@i18n-quote-option-list-occupation-option-160': 'LETRAS',
  '@i18n-quote-option-list-occupation-option-161': 'LICORERO BODEGUERO LUNCHERO',
  '@i18n-quote-option-list-occupation-option-162': 'LIMOSNERO',
  '@i18n-quote-option-list-occupation-option-163': 'LIMPIABOTAS',
  '@i18n-quote-option-list-occupation-option-164': 'LOCUTOR DE RADIO, TV',
  '@i18n-quote-option-list-occupation-option-165': 'LOQUERO',
  '@i18n-quote-option-list-occupation-option-166': 'LOTERO',
  '@i18n-quote-option-list-occupation-option-167': 'MALETERO',
  '@i18n-quote-option-list-occupation-option-168': 'MANICURISTA',
  '@i18n-quote-option-list-occupation-option-169': 'MAQUINA DE AVION DE NAVEGACION',
  '@i18n-quote-option-list-occupation-option-170': 'MASAJISTA',
  '@i18n-quote-option-list-occupation-option-171': 'MATEMATICA',
  '@i18n-quote-option-list-occupation-option-172': 'MAYORDOMO',
  '@i18n-quote-option-list-occupation-option-173': 'MECANICO LATONERO PINTOR DE VEHICULO',
  '@i18n-quote-option-list-occupation-option-174': 'MECANOGRAFO ESCRIBIENTE TRANSCRIPTOR',
  '@i18n-quote-option-list-occupation-option-175': 'MEDICINA VETERINARIA',
  '@i18n-quote-option-list-occupation-option-176': 'MEDICINA Y PSIQUIATRA',
  '@i18n-quote-option-list-occupation-option-177': 'MENSAJERO',
  '@i18n-quote-option-list-occupation-option-178': 'MERCADOTECNIA, PUBLICIDAD  Y TURISMO',
  '@i18n-quote-option-list-occupation-option-179': 'MESONERO',
  '@i18n-quote-option-list-occupation-option-180': 'MILITAR',
  '@i18n-quote-option-list-occupation-option-181': 'MINERO',
  '@i18n-quote-option-list-occupation-option-182': 'MINERO CANTERO',
  '@i18n-quote-option-list-occupation-option-183': 'MODELO',
  '@i18n-quote-option-list-occupation-option-184': 'MOTORIZADO',
  '@i18n-quote-option-list-occupation-option-185': 'MUSICO',
  '@i18n-quote-option-list-occupation-option-186': 'NUTRICION Y DIETETICA',
  '@i18n-quote-option-list-occupation-option-187': 'OBRERO',
  '@i18n-quote-option-list-occupation-option-188': 'ODONTOLOGIA',
  '@i18n-quote-option-list-occupation-option-189': 'OFICINISTA',
  '@i18n-quote-option-list-occupation-option-190': 'OPERADOR DE EQUIPOS Y MAQUINAS',
  '@i18n-quote-option-list-occupation-option-191': 'PANADERO PASTELERO CARNICERO QUESERO',
  '@i18n-quote-option-list-occupation-option-192': 'PARAMEDICO',
  '@i18n-quote-option-list-occupation-option-193': 'PARQUERO',
  '@i18n-quote-option-list-occupation-option-194': 'PASANTE',
  '@i18n-quote-option-list-occupation-option-195': 'PEDICURISTA',
  '@i18n-quote-option-list-occupation-option-196': 'PELUQUERO',
  '@i18n-quote-option-list-occupation-option-197': 'PERITO VALUADOR',
  '@i18n-quote-option-list-occupation-option-198': 'PESCADOR',
  '@i18n-quote-option-list-occupation-option-199': 'PILOTO DE AVION NAVEGACION VEHICULO',
  '@i18n-quote-option-list-occupation-option-200': 'PINTOR',
  '@i18n-quote-option-list-occupation-option-201': 'PLOMERO',
  '@i18n-quote-option-list-occupation-option-202': 'POLICIA',
  '@i18n-quote-option-list-occupation-option-203': 'POLITICO',
  '@i18n-quote-option-list-occupation-option-204': 'PORTERO',
  '@i18n-quote-option-list-occupation-option-205': 'PREPARADOR DE PAPEL',
  '@i18n-quote-option-list-occupation-option-206': 'PRESIDENTE (EMPRESA, CLUB, ORGANIZACIÓN)',
  '@i18n-quote-option-list-occupation-option-207': 'PRESTAMISTA',
  '@i18n-quote-option-list-occupation-option-208': 'PRODUCTOR (TEATRO, CINE, RADIO O TV)',
  '@i18n-quote-option-list-occupation-option-209': 'PSICOLOGIA',
  '@i18n-quote-option-list-occupation-option-210': 'PUBLICISTA',
  '@i18n-quote-option-list-occupation-option-211': 'QUIMICA',
  '@i18n-quote-option-list-occupation-option-212': 'RECEPCIONISTA',
  '@i18n-quote-option-list-occupation-option-213': 'RECREADOR',
  '@i18n-quote-option-list-occupation-option-214': 'RECTOR VICERECTOR DECANO',
  '@i18n-quote-option-list-occupation-option-215': 'RELACIONES INDUSTRIALES',
  '@i18n-quote-option-list-occupation-option-216': 'RELOJERO',
  '@i18n-quote-option-list-occupation-option-217': 'SACERDOTE RELIGIOSO MONJA PASTOR',
  '@i18n-quote-option-list-occupation-option-218': 'SALVAVIDAS RESCATISTA',
  '@i18n-quote-option-list-occupation-option-219': 'SASTRE',
  '@i18n-quote-option-list-occupation-option-220': 'SECRETARIA',
  '@i18n-quote-option-list-occupation-option-221': 'SINDICALISTA',
  '@i18n-quote-option-list-occupation-option-222': 'SOLDADOR',
  '@i18n-quote-option-list-occupation-option-223': 'SUBASTADOR TASADOR',
  '@i18n-quote-option-list-occupation-option-224': 'SUPERVISOR COORDINADOR',
  '@i18n-quote-option-list-occupation-option-225': 'TABAQUERO CIGARRERO',
  '@i18n-quote-option-list-occupation-option-226': 'TALLADOR',
  '@i18n-quote-option-list-occupation-option-227': 'TAPICERO',
  '@i18n-quote-option-list-occupation-option-228': 'TAQUIGRAFO MECANOGRAFO',
  '@i18n-quote-option-list-occupation-option-229': 'TECNICO DE EQUIPOS ELECTRICOS ELECTRONICOS COMPUTACION MECANICO',
  '@i18n-quote-option-list-occupation-option-230': 'TECNICO DE LAS CIENCIAS MEDICAS',
  '@i18n-quote-option-list-occupation-option-231': 'TECNICO DE MINAS',
  '@i18n-quote-option-list-occupation-option-232': 'TECNICO DE SONIDO',
  '@i18n-quote-option-list-occupation-option-233': 'TECNICO EN CIENCIAS BIOLOGICAS Y AGRONOMICAS',
  '@i18n-quote-option-list-occupation-option-234': 'TECNICO EN CIENCIAS FISICAS Y QUIMICAS',
  '@i18n-quote-option-list-occupation-option-235': 'TECNICO MECANICO METALURGICO',
  '@i18n-quote-option-list-occupation-option-236': 'TELEFONISTA',
  '@i18n-quote-option-list-occupation-option-237': 'TELEGRAFISTA',
  '@i18n-quote-option-list-occupation-option-238': 'TINTORERO',
  '@i18n-quote-option-list-occupation-option-239': 'TIPOGRAFO',
  '@i18n-quote-option-list-occupation-option-240': 'TOPOGRAFO',
  '@i18n-quote-option-list-occupation-option-241': 'TRABAJADOR SEXUAL',
  '@i18n-quote-option-list-occupation-option-242': 'TRADUCTOR',
  '@i18n-quote-option-list-occupation-option-243': 'TURISMO',
  '@i18n-quote-option-list-occupation-option-244': 'VENDEDOR PROMOTOR',
  '@i18n-quote-option-list-occupation-option-245': 'VENDEDOR DE BIENES RAICES',
  '@i18n-quote-option-list-occupation-option-246': 'VISITADOR MEDICO',
  '@i18n-quote-option-list-occupation-option-247': 'ZAPATERO',
  '@i18n-quote-option-list-occupation-option-248': 'ZOOTECNIA',


  '@i18n-quote-pn-form-label-country-of-birth': 'País',


  '@i18n-section-title-PERSONAL_INFORMATION_BIRTH_DATA': 'Información de Nacimiento',

  '@i18n-quote-RELATED-PEP-PN-RELATIONSHIP-modal-section-title': 'Parentesco con PEP',


  '@i18n-quote-fiscalAddress-form-label-additional_info': 'Dirección',
  '@i18n-quote-businessData-form-label-startDateOperations': 'Inicio de Operaciones',
  '@i18n-quote-businessData-form-label-businessType': 'Tipo de Negocio',
  '@i18n-quote-businessData-form-label-email': 'Correo',


  'FISCAL_ADDRESS_PRINCIPAL': 'Dirección Fiscal',
  'FISCAL_ADDRESS_OFICINA': 'Dirección Otra',
  '@i18n-login-error-user-inactive': 'El usuario se encuentra inactivo',
  '@i18n-login-error-user-inactive-text': 'Revise su correo electrónico, abra el correo recibido de {clientName} y presione el link de verificación',




'newwwwww':'nuevo diseño ',


'@i18n-title-header-menu-left':"Solicitudes",
'@i18n-sworn-text-1': 
`
<div class="mt-3">
Si está de acuerdo que todos los datos y recaudos suministrados por usted es correcta y veraz, proceda a darle click al botón  “Aceptar”. 
</div> 
`,

'@i18n-sworn-text-2': 
`
<div class="mt-3" style=" font-size: 1rem;" >
A continuación se muestra los documentos vinculados con los datos de la solicitud y que deberás  descargar,firmar y adjuntar mediante la opción de recaudos</div> 
`,


'@i18n-summary-account-opening-step-upload-file-plan': 'Conoce sobre los recaudos',

'@i18n-text-title-apply-login': '¿Ya eres cliente de {clientName}?',
'@i18n-text-button-apply-login': 'Ingresa con tu usuario',

'@i18n-text-title-apply-register': '¿Eres cliente nuevo?',
'@i18n-text-button-apply-register': 'Regístrate y Solicítalo',




"------------------":"",

'@i18n-quote-customers-customersTable-section.title': '',
'@i18n-quote-createuser-applicantype-section-title':`
<div>
<span class="pt-2 pb-2 font-weight-light" >Comienza ahora </span>
<div class="line">
    <div class="line2 font-weight-light"></div>
</div> 
</div>
<!-- <div class="mt-4 mb-4">

        <div class ="base-description-section-top base-description-section-top-bg p-2" >
       
        <div class="font-weight-bold pb-3" >
          <b>Estimado Cliente,</b>
        </div>
        <div pb-1>
        A través de este portal Ud. podrá realizar digitalmente la preapertura de cuentas de manera segura.
        </div>
        <div>
          Antes de iniciar el proceso de solicitud, asegúrese de tener guardado en su equipo o dispositivo, la copia escaneada de los recaudos que se requieren para la cuenta. En caso de no tenerlos podra adjuntarlos luego.      </div>
        </div>-->
`,   

'@i18n-quote-createUser-whatsYourName-section-title': '',
'@i18n-quote-createUser-whatsYourName-section-description': '', 
'@i18n-quote-createUser-whatsYourEmail-section-title': '',
'@i18n-quote-createUser-whatsYourEmail-section-description': '',
'@i18n-quote-createUser-howStartSession-section-title': '¿Cómo vas a iniciar sesión?',
'@i18n-quote-createUser-howStartSession-section-description': 'Tu debes utilizar este nombre de usuario para iniciar sesión en esta plataforma de gestión de solicitudes',


"@i18n-pep-quote-option-list-boolean-option-false":'No',
"@i18n-pep-quote-option-list-boolean-option-true":'Si',
'@i18n-quote-legalRepresentative-pep-form-label-itsApep-help': 'PEP: Desempeña o ha desempeñado un cargo o función pública',

"@i18n-relatedToPEP-quote-option-list-boolean-option-false":'No',
"@i18n-relatedToPEP-quote-option-list-boolean-option-true":'Si',


"@i18n-relatedToPepAssociation-quote-option-list-boolean-option-false":'No',
"@i18n-relatedToPepAssociation-quote-option-list-boolean-option-true":'Si',


"@i18n-legalRepresentativePep-quote-option-list-boolean-option-false":'NO',
"@i18n-legalRepresentativePep-quote-option-list-boolean-option-true":'Si',

"@i18n-legalRepresentativeIsRelatedToPep-quote-option-list-boolean-option-false":'No',
"@i18n-legalRepresentativeIsRelatedToPep-quote-option-list-boolean-option-true":'Si',


'@i18n-quote-relationOfLaborDependency-form-label-haveRelationshipOfLaborDependence': '¿Trabaja usted para una empresa?',
"@i18n-relationOfLaborDependency-quote-option-list-boolean-option-false":'No',
"@i18n-relationOfLaborDependency-quote-option-list-boolean-option-true":'Si',



'@i18n-quote-ownBusiness-form-label-haveOwnBusiness': '¿Tiene usted negocio propio?',
"@i18n-ownBusiness-quote-option-list-boolean-option-false":'No',
"@i18n-ownBusiness-quote-option-list-boolean-option-true":'Si',


'@i18n-quote-anotherSourceIncome-form-label-haveAnotherSourceIncome': '¿Tiene usted otras fuentes de ingresos?',
"@i18n-anotherSourceIncome-quote-option-list-boolean-option-false":'No',
"@i18n-anotherSourceIncome-quote-option-list-boolean-option-true":'Si',

'@i18n-quote-bankAccount-form-label-checkInstitution': '¿Posee usted cuentas bancarias o productos financieros con <b>{clientName}</b>?',
"@i18n-bankAccount-quote-option-list-boolean-option-false":'No',
"@i18n-bankAccount-quote-option-list-boolean-option-true":'Si',


'@i18n-quote-bankAccount-form-label-checkOtherInstitution': '¿Posee usted  cuentas bancarias o productos financieros con otras instituciones financieras?',
"@i18n-bankAccountOther-quote-option-list-boolean-option-false":'No',
"@i18n-bankAccountOther-quote-option-list-boolean-option-true":'Si',

"@i18n-legalRepresentativeList-quote-option-list-boolean-option-false":'No poseo',
"@i18n-legalRepresentativeList-quote-option-list-boolean-option-true":'Si',

'@i18n-quote-suppliers-form-label-checkSuppliers': '¿Tiene usted principales proveedores?',
'@i18n-quote-customers-form-label-checkCustomers': '¿Tiene usted principales clientes?',




'@i18n-quote-relatedPerson-form-label-checkRelatedCompanies': 'Identifique las empresas relacionadas',
"@i18n-relatedCompanies-quote-option-list-boolean-option-false":'No tengo  empresas relacionadas',
"@i18n-relatedCompanies-quote-option-list-boolean-option-true":'Identificar',

'@i18n-quote-commercialReferences-form-label-checkCommercialReferences': 'Identifique las referencias comerciales <span  class="small text-secondary" >(corresponden a lo señalado en principales proveedores) </span> ',
"@i18n-checkCommercialReferences-quote-option-list-boolean-option-false":'No poseo  referencias comerciales',
"@i18n-checkCommercialReferences-quote-option-list-boolean-option-true":'Si, poseo   referencias comerciales',


'@i18n-register-text-standard': 'Agregue su(s) ',
'@i18n-register-text-standard-paperwork': 'No se encontraron solicitudes',
'@i18n-register-text-standard-table': 'Lista de ',
'@i18n-new': '<i class="fas fas fa-credit-card mr-1"></i> Nueva Solicitud',
'@i18n-new-product': ' <i class="pr-1 ak-text-color-4   pr-1 ak-text-color-4   fas fa-credit-card"></i> Nueva Solicitud',


'@i18n-paperwork-title': 'Mis solicitudes',



'@i18n-quote-legalRepresentative-pep-modal-section-title': 'Parentesco con PEP',
'@i18n-quote-legalRepresentative-asociados-pep-modal-section-title': 'PEP Relacionados',


'@i18n-pep-table-title': 'Personas relacionadas Expuestas Políticamente ',

"@i18n-quote-PEP-PN-modal-section-title": "PEP",

'@i18n-quote-subtitle':'',

'@i18n-hello':'Hola ',
'@i18n-transaction-m': 'Solicitud N°',

'@i18n-transactions-title': 'Mis Solicitudes',
'@i18n-transaction-title': 'Solicitud',
'@i18n-menu-label-client-transactions': 'Mis Solicitudes',


'new-i18ns':'26/04/-------------------------------------------',

'@i18n-stage-product-information': 'Producto Solicitado',
'@i18n-quote-label-termsAndConditionsTitle': 'Cierre de la Solicitud',
'@i18n-quote-productInformation-form-label-agency': 'Requerido',
'@i18n-section-title-PERSONAL_INFORMATION': '',
'@i18n-quote-legalRepresentativePN-section.title': 'Representante Legal',
'@i18n-quote-bankingProductsWithTheInstitution-modal-section-title': 'Productos con el banco',
'@i18n-quote-bankAccount-form-label-currency': 'Seleccione la moneda',
"@i18n-quote-accreditedRecord-form-label-civilStatus-option-concubinage": "Unión Estable de Hecho",
'@i18n-quote-businessData-form-label-nationality': 'Nacionalidad',
'@i18n-quote-fiscal-directions-section.title-plural-legal': 'direcciones/sucursales',
'@i18n-quote-legalRepresentative-section.title': 'Representante Legal',

'@i18n-text-user-registred-detail': 'Ingrese a su correo electrónico, donde recibirá un correo de {clientName} para verificar su usuario y continuar el proceso de pre-apertura de cuenta. Si no recibe el correo, por favor verifique en la bandeja de spam o correos no deseados.',
"@i18n-quote-legalRepresentative-form-label-checkLegalRepresentative": "Posee usted Representante Legal",
"@i18n-step-disabled":"Complete el paso anterior",

"--------------------------030521":"",


"@i18n-description-bottom-isPep":"",

"@i18n-description-top-relatedToPEP": ``,



"@i18n-description-top-relatedToPepAssociation": ``,

'@i18n-quote-RELATED-PEP-PN-ASSOCIATION-modal-section-title': "PEP Relacionados",
"@i18n-quote-RELATED-PEP-PN-modal-section-title": "PEP Relacionados",

'@i18n-quote-option-list-accountType-tdc': 'Tarjeta de Crédito',

'@i18n-text-login':'Login',
'@i18n-summary-account-opening-step-name': 'Inicio',
'@i18n-quote-termsAndConditions': 'Al enviar esta solicitud <b>acepta</b>  <a target=blank href={urlDocumentConditions}> Términos y Condiciones</a>  de la solicitud.',



 '@i18n-guide-account-activation-description':'Bienvenida y retiro del producto',
 '@i18n-guide-product-information-description': 'Datos y parámetros del producto 3 min',
 '@i18n-guide-client-identification-description':'La información del cliente 8 min',
 '@i18n-guide-account-contract-analysis-description':'Revisión por nuestros analistas',
 '@i18n-guide-account-contract-description':'Enviar solicitud para el análisis 1 dia',
 '@i18n-guide-requirement-description':'Registrar recaudos 5 min',




 "@i18n-new-solicitud": ``,


 '@i18n-text-register': 'Hazte Cliente',
  '@i18n-text-only-can-register-one-principal-direction': 'Solo se puede agregar una Dirección Fiscal',
  '@i18n-rq-box-msg':"Para mayor rapidez en el proceso de aprobación de su solicitud, le sugerimos consignar la mayor cantidad de recaudos posibles digitalmente. Recuerde que al momento de formalizar la Apertura de Cuenta en la agencia seleccionada, debe consignar la totalidad de los recaudos solicitados en físico.",
 
  "@i18n-quote-option-list-accountType-currencyCustody": "Cuenta en Divisas",
  "@i18n-quote-option-list-accountType-foreign-exchange": 'Cuenta en Divisas',
 
 
  '@i18n-quote-personalInformation-section.title': 'Datos Básicos',
  '@i18n-quote-legalRepresentative-pep-form-label-institutionName': ` <div class="label-form-btn mb-2 fz-16"> Persona Expuesta Políticamente</div> <div class="text-form-description pb-4">Por favor, es necesario que identifique el ente, institución y país donde se desempeña o se ha desempeñado. </div> <span class="pt-2">Nombre de la Institución / Ente de Adscripción<span>`, 
 
 
  '@i18n-quote-ownBusiness-suppliers-form-label-checkSuppliers': '¿Tiene usted principales proveedores?',
 "@i18n-checkSuppliersPN-quote-option-list-boolean-option-false":'No',
 "@i18n-checkSuppliersPN-quote-option-list-boolean-option-true":'Si',
 
 
 '@i18n-quote-ownBusiness-customers-form-label-checkCustomers': '¿Tiene usted principales clientes?',
 "@i18n-checkCusomersPN-quote-option-list-boolean-option-false":'No',
 "@i18n-checkCusomersPN-quote-option-list-boolean-option-true":'Si',
 
 '@i18n-legalRepresentativePep-legalRepresentative-pep-form-label-itsApep': 'Es usted una Persona Expuesta Políticamente',
 '@i18n-pep-pn-account-opening-step-name': 'Persona Expuesta Políticamente',
 
 
 
 
 '@i18n-quote-legalRepresentative-pep-form-label-itsApep': `
 <div class="mb-2 mb-md-0" >¿Es una Persona Expuesta Políticamente” (PEP)? </div>
 
 <div class="text-form-description d-block d-md-none">Es una persona natural que es o fue figura política de alto nivel, de confianza o afines, o sus familiares más cercanos o su círculo de colaboradores inmediatos, por ocupar cargos como funcionario o funcionaria importante de un órgano ejecutivo, legislativo, judicial o militar de un gobierno nacional o extranjero, elegido o no, un miembro de alto nivel de un partido político nacional o extranjero o un ejecutivo de alto nivel de una corporación, que sea propiedad de un gobierno extranjero. En el concepto de familiares cercanos se incluye a los padres, hermanos, cónyuges, hijos o parientes políticos de la persona expuesta políticamente. También se incluye cualquier persona jurídica que como corporación, negocio u otra entidad que haya sido creada por dicho funcionario o funcionaría en su beneficio.</div>
 `,
 
 
 '@i18n-quote-legalRepresentative-pep-form-label-isRelatedToPep': 
 `<div class=" mb-2 mb-md-0 " >¿Tiene parentesco con PEP?</div>
 <div class="text-form-description d-block d-md-none">Incluye a sus padres, hermanos, cónyuges, hijos o parientes políticos (Sobrino/a Abuelo/a Nieto/a Bisnieto/a Tío/a, Primo/a, Suegro/a, Yerno / Nuera Cuñado/a, Abuelo/a del cónyuge Tío/a del cónyuge Sobrino/a del cónyuge Primo/a del cónyuge)</div>
 
 `,
 
 
 '@i18n-quote-legalRepresentative-pep-form-label-isNotRelatedToPepAssociation':
 `<div class="mb-2 mb-md-0" >¿Tiene PEP Relacionados?</div>
 <span class="text-form-description  d-block d-md-none">Incluye a su círculo de colaboradores inmediatos (Socios y Personas con relación de dependencia)</span>`,
  
 
 '@i18n-quote-legalRepresentative-pep-form-label-have-pep-realtionship':
 `<div class=" class="mb-2 mb-md-0 " >¿Tiene parentesco con PEP?</div>
 <span class="text-form-description  d-block d-md-none">Incluye a sus padres, hermanos, cónyuges, hijos o parientes políticos (Sobrino/a Abuelo/a Nieto/a Bisnieto/a Tío/a, Primo/a, Suegro/a, Yerno / Nuera Cuñado/a, Abuelo/a del cónyuge Tío/a del cónyuge Sobrino/a del cónyuge Primo/a del cónyuge)</span>
 `,
 
 '@i18n-htmlRightTemplete-PEP_PN':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
             Persona Expuesta Políticamente (PEP)
         </div>
 
         <div class="text-form-description"><b>PEP</b>, Se refiere a una persona natural (usted) que ha sido (en los últimos 5 años) o es figura política de alto nivel, de confianza o afines; es decir, ocupó u ocupa cargos públicos (funcionario importante de un órgano ejecutivo, legislativo,
             judicial o militar de un gobierno nacional o extranjero, elegido o no, un miembro de alto nivel de un partido político nacional o extranjero o un ejecutivo de alto nivel de una corporación que sea propiedad de un gobierno extranjero).</div>
     </div>
 </div>
 `,
 
 
 '@i18n-htmlRightTemplete-RELATED_PEP_ASSOCIATION_PN':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
             PEP Relacionados
         </div>
 
         <div class="text-form-description ">Incluye a su círculo de colaboradores inmediatos (Socios y Personas con relación de dependencia)</div>
 
     </div>
 </div>
 `,
 
 
 '@i18n-htmlRightTemplete-RELATED_PEP_PN':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
              Parentesco con PEP
         </div>
 
         <div class="text-form-description ">Incluye a sus padres, hermanos, cónyuges, hijos o parientes políticos (Sobrino/a Abuelo/a Nieto/a Bisnieto/a Tío/a, Primo/a, Suegro/a, Yerno / Nuera Cuñado/a, Abuelo/a del cónyuge Tío/a del cónyuge Sobrino/a del cónyuge Primo/a del cónyuge)</div>
      </div>
 </div>
 `,
 


 
 '@i18n-htmlRightTemplete-PERSONAL_INFORMATION':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Datos Básicos
         </div>
 
         <div class="text-form-description ">
         Se refiere a su información personal, como: nombres, apellidos, estado civil, edad, género, profesión y ocupación.<br><br>Esta información estará visible a su ejecutivo asignado. De este modo, le resultará más fácil ponerse en contacto con usted.
         </div>
      </div>
 </div>
 `,

 '@i18n-htmlRightTemplete-PERSONAL_INFO_REDUCED':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Datos Básicos
         </div>
 
         <div class="text-form-description ">
         Se refiere a su información personal, como: nombres, apellidos, estado civil, edad, género, profesión y ocupación.<br><br>Esta información estará visible a su ejecutivo asignado. De este modo, le resultará más fácil ponerse en contacto con usted.
         </div>
      </div>
 </div>
 `,


 '@i18n-htmlRightTemplete-HOME_ADDRESS':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Dirección de Domicilio
         </div>
 
         <div class="text-form-description ">
         Se refiere a la dirección de residencia permanente. Debe coincidir con la dirección en el recibo de servicio y el documento del RIF personal.</div>

         <div>
         <div class="text-form-description ">
         Tenga encuenta que la dirección que ingrese debe coincidir con la dirección de domicilio registrada en su documento de Registro de Información Fiscal (RIF)  
      </div>
         </div>
      </div>
 </div>
 `,


 '@i18n-htmlRightTemplete-CONTACT_MEANS_PN':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
          Medios de Contacto
         </div>
 
         <div class="text-form-description ">
         Indique todos los medios de contactos por medios de los cuales podemos ponernos en contacto con usted.
         
         </div>
      </div>
 </div>
 `,
 
 
 
 

 '@i18n-htmlRightTemplete-LEGAL_REPRESENTATIVE_PN':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
 <div >
     <div class="base-description-section-top mb-2 font-weight-bold">
     Representante Legal
     </div>

     <div class="text-form-description ">
     Se refiere a la facultad otorgada por la ley a una persona para obrar en nombre de usted;  sea en nombre de una persona natural o de una persona jurídica.     
     </div>
  </div>
</div>

 `,

 '@i18n-htmlRightTemplete-ECONOMIC_ACTIVITY_PN':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Actividad económica
         </div>
 
         <div class="text-form-description ">
         Se refiere a cualquier actividad cuyo objetivo sea cubrir una necesidad o deseo. Independientemente de que sea produciendo, intermediando o vendiendo algún bien o servicio. Adicionalmente, se incluyen también, por origen, todas aquellas actividades cuyo fin no sea el lucro.         
         </div>
      </div>
 </div>
 `,



 '@i18n-htmlRightTemplete-RELATION_OF_LABOR_DEPENDENCY':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Dependencia Laboral
         </div>
 
         <div class="text-form-description ">
         Se refiere al vínculo laboral que usted posea con una empresa a través de un contrato de trabajo.          </div>
      </div>
 </div>
 `,




 '@i18n-htmlRightTemplete-OWN_BUSINESS':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Negocio propio      
            </div>
 
         <div class="text-form-description ">
         Se refiere al emprendimiento personal o empresa constituida que posea actualmente.
               </div>
 </div>
 `,




 '@i18n-htmlRightTemplete-ANOTHER_SOURCE_INCOME':`
 <div class="p-1 pl-2  mt-2 mb-2 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
         Otras fuentes de ingreso     
            </div>
 
         <div class="text-form-description ">
         Indique si posee otra actividad distinta con la que genera ingresos.               </div>
 </div>
 `,





 
 '@i18n-htmlRightTemplete-INTER_IDENTITY_VERIF_INFO':`
 
 <div class="p-1 pl-2  mt-2 mb-2 pt-3 ">
     <div >
         <div class="base-description-section-top mb-2 font-weight-bold">
             Información de Identidad
         </div>
 
         <div class="text-form-description ">Estos datos deben coincidir con su información legal tal y como aparece en su documento de identificación.
         </div>
      </div>
 </div>
 
 `,



 
 '@i18n-quote-interIdentityVerifInfo-section.title':`
 <div class="text-left pt-4">

 <div>
     <span class="pt-2 pb-2 font-weight-light">Verifícate</span>
     <div class="line">
         <div class="line2 font-weight-light"></div>
     </div>
 </div>
 <div class="mt-4 mt-2 ">

     <h4 class="title-section">Información de Identidad</h4>

 </div>

</div>


     `,

     '@i18n-workflow-name-accountlevel2':'Cuenta de Corretaje Bursátil (CCBU) Nivel 2 <br> (Moviliza más de Bs. 1.000,00 mensuales)',
     '@i18n-workflow-name-accountlevel1':'Cuenta de Corretaje Bursátil (CCBU) Nivel 1 <br>(Moviliza hasta Bs. 1.000,00 mensuales)',
   
     '@i18n-menu-label-client-inbox': 'Con respuesta',
     '@i18n-menu-label-client-sent': 'En análisis',
     '@i18n-menu-label-client-draft': 'Borrador',
     '@i18n-stage-account-contract': 'Declaración Jurada y Planilla',
     '@i18n-account-contract-step-name': 'Enviar solicitud',
     '@i18n-account-contract-opening-step-name': 'Enviar solicitud',
     '@i18n-quote-sendCustomerData-section.title':``,




     '@i18n-htmlSubTitle-PERSONAL_INFORMATION':`Permítanos conocerle y contactarle más fácilmente. Su información personal estará protegida.`,
    
     '@i18n-htmlSubTitle-PEP_PN':`Indíquenos si es una persona con responsabilidades públicas prominentes y/o familiares o allegados con funciones de esta índole.  `,
     
     '@i18n-htmlSubTitle-ECONOMIC_INFORMATION':`Cuéntenos acerca de su fuente de recursos o ingresos. Suministre toda la información necesaria.`,

     '@i18n-htmlSubTitle-PERSONAL_REFERENCES':`Agregue a su grupo de personas cercanas (familiar, amigo, vecino, jefe, compañero de trabajo) que brinden un testimonio genuino de usted.`,

     '@i18n-htmlSubTitle-REFERENCES':`Agregue los datos bancarios necesarios del manejo de cuentas que posee en esta institución o en otras instituciones. `,
'@i18n-workflow-name-documentsupport':'Recaudos',


'@i18n-workflow-name-clientdatareduced' :'Información Personal',
'@i18n-htmlSubTitle-PERSONAL_INFO_REDUCED' : 'Permítanos conocerle y contactarle más fácilmente. Su información personal estará protegida.',
'clientNameShort':'{clientNameShort}',
'@i18n-termAndConditions':`

<b>Declaración de conocimiento del contrato.</b><br>
El (los) firrmante(s) declara(n) expresamente: haber leído, comprendido y aceptado los términos y condiciones de los documentos y el contrato de cuenta de corretaje bursátil suscritos, y se obliga(n) a que su relación contractual con Rendivalores Casa de Bolsa, C.A. estará sujeta a los términos y condiciones establecidos en los mismos. De igual forma, certifican la veracidad y autenticidad de la información y datos suministrados en la presente ficha del inversor.”
<br><br>
<b>Declaración Jurada de Origen y Destino de Fondos.</b><br>
El (los) firrmante (s) declara (n) que: “Los capitales, bienes, fondos, haberes o beneficios no provienen de ninguna actividad ilícita de las contempladas en las leyes penales vigentes y, en especial, de las previstas en la Ley Orgánica contra la Delincuencia Organizada y Financiamiento al Terrorismo y, en especial, relativas a los delitos de Legitimación de Capitales, Financiamiento al Terrorismo y Financiamiento de la Proliferación de Armas de Destrucción Masiva (LC/FT/FPADM)”."
<br><br>
Al "Aceptar" doy fe que toda la información es fidedigna.`,

'@i18n-msg-cuentas':
`
Los números de cuentas que ingreses aquí serán las permitidas para transferir dinero (fondear) a tu cuenta de corretaje bursátil con Rendivalores y también serán las mismas a las que Rendivalores te realice los depósitos. 
<br><br>
Registra cuentas bancarias propias. No se permite el uso de cuentas ajenas al titular.

`,

'@i18n-declaracionJurada-contrato':`
<div class="mt-2"> 

 <div>`,

 '@i18n-formatoSol':`Cuando su solicitud este lista descargue la Ficha Única, el Contrato y Declaración Jurada. Debe firmarlos y anexarlos en el recaudo de Formatos de la Solicitud
 `,

 '@i18n-quote-bankingProductsWithOtherInstitution-modal-section-title': 
 `
 Cuentas Bancarias
 <div class='fz-14 text-secondary' >
 Debes ser el titular, y no se permiten cuentas cuyo titular sea diferente a la persona que abre la cuenta de corretaje bursátil.
 </div>
 `,


 '@i18n-quote-homeAddress-form-label-country':  
 `
 <div class="text-secondary font-weight-normal alert alert-warning p-3 mt-4 mb-4 animate__animated animate__fadeIn ">
                                <span >Tenga encuenta que la dirección que ingrese debe coincidir con la dirección de domicilio registrada en su documento de Registro de Información Fiscal (RIF)</span>
</div>

 <div>País</div>
  
 `,
 '@i18n-product-long-description-product1-2':`
  
      <div class="fz-14" ><b>Cuenta de Corretaje Bursátil (CCBU)</b></div>
      
      <div class="fz-14" >Nivel 1</div>

      <div class="fz-14 text-secondary mt-2" >  
      Deseo invertir hasta mil (1000) veces el tipo de cambio oficial de la moneda de mayor valor publicado por el Banco Central de Venezuela (BCV) mensuales.
      </div>

    </div>


  `,
  
  '@i18n-product-long-description-product1-3':`


  <div class="fz-14" ><b>Cuenta de Corretaje Bursátil (CCBU)</b></div>
      
  <div class="fz-14" >Nivel 2</div>

  <div class="fz-14 text-secondary mt-2" >  
  Deseo invertir más de mil y un (1000) veces el tipo de cambio oficial de la moneda de mayor valor publicado por el Banco Central de Venezuela (BCV) mensuales.
   </div>
`,



'@i18n-product-long-description-product1-4':`


<div class="fz-14" ><b>Fondo Mutual Rendivalores</b></div>
    
<div class="fz-14 text-secondary mt-2" >  
Registro en Fondo Mutual de Capital Abierto</div>
`,

'@i18n-quote-investorProfile-section.title':'',
'@i18n-modal-transacton-product-title':'',
'@i18n-modal-transacton-plan-title':'Selecciona el tipo de cuenta',

'@i18n-quote-investorProfile-form-label-experience': 'Experiencia como inversionista' ,
'@i18n-quote-investorProfile-form-label-objective': 'Objetivo dentro de un Ciclo de Inversión' ,
'@i18n-quote-investorProfile-form-label-investments': 'Inversiones' ,
'@i18n-quote-investorProfile-form-label-savings': 'Ahorros' ,
'@i18n-quote-investorProfile-form-label-passives': 'Pasivos' ,
'@i18n-quote-investorProfile-form-label-totalAssets': 'Total Patrimonio' ,

'@i18n-quote-option-list-investorExperience-option1': 'Ninguna' ,
'@i18n-quote-option-list-investorExperience-option2': 'Limitada' ,
'@i18n-quote-option-list-investorExperience-option3': 'Buena' ,
'@i18n-quote-option-list-investorExperience-option4': 'Excelente',
'@i18n-quote-productInformation-form-label-averageMonthlyAmount': 'Monto aproximado de promedio mensual que desea invertir',
'@i18n-quote-productInformation-form-label-numberOfCreditTransactions': 'Cantidad de Operaciones',
'@i18n-quote-productInformation-form-label-numberOfDebitTransactions': 'Cantidad de retiros',
'@i18n-quote-productInformation-form-label-requestReason': 'Producto y/o motivos por los cuales solicita los servicios',

'@i18n-quote-option-list-requestReason-option1':'Titularización',
'@i18n-quote-option-list-requestReason-option2':'Unidad de Inversión',
'@i18n-quote-option-list-requestReason-option3':'Pagaré Bursátil',
'@i18n-quote-option-list-requestReason-option4':'Bono de Deuda Pública Nacional',
'@i18n-quote-option-list-requestReason-option5':'Bono de Prueba',
'@i18n-quote-option-list-requestReason-option6':'Contratos de Compra y Venta de Productos Físicos',
'@i18n-quote-option-list-requestReason-option7':'Contratos de Opciones y Futuros',
'@i18n-quote-option-list-requestReason-option8':'Certificados de Depósitos',
'@i18n-quote-option-list-requestReason-option9':'Títulos de Participación',
'@i18n-quote-option-list-requestReason-option10':'Obligaciones',
'@i18n-quote-option-list-requestReason-option11':'Facturas',
'@i18n-quote-option-list-requestReason-option12':'Contrato de Reportes Bursátiles Agricola',


'@i18n-send-customer-data-step-name':'Finalizar',

'@i18n-quote-relationOfLaborDependency-section.title': 'Dependencia Laboral',
'@i18n-quote-relationOfLaborDependency-detail-section.title': 'Datos de Dependencia Laboral',
'@i18n-quote-ownBusiness-section.title': 'Negocio Propio',
'@i18n-quote-ownBusiness-section-detail.title': 'Datos de  Negocio Propio',

'@i18n-quote-relationOfLaborDependency-form-label-remuneration': 'Remuneración Mensual',
'@i18n-quote-productInformation-section.title': 'Perfil Transaccional',

'@i18n-quote-pn-form-label-startDate':'Fecha de Inicio',
'@i18n-quote-pn-form-label-dueDate':'Fecha de culminación',

'@i18n-quote-spouse-form-label-occupation':'Profesión u Oficio',

  '@i18n-quote-productInformation-form-label-currency': `<div class="text-secodary font-weight-normal fz-16 mt-3 mb-2">Seleccione la <b>moneda</b> para su cuenta</div>`,


  '@i18n-quote-option-list-investorProfile-option1':
  
  `
  <div class="text-left">
    <div class=" fz-12 font-weight-bold  mb-1" >AGRESIVO</div>
    <div class="fz-12">
      Tengo alta tolerancia a la pérdida de capital, por lo que me gustaría que mis inversiones generaran los mayores rendimientos posibles. Estoy dispuesto a aceptar fluctuaciones negativas por períodos mayores a dos años, incluyendo la posible pérdida de mi inversión inicial.
    </div>

  `,
'@i18n-quote-option-list-investorProfile-option2':


`
<div class="text-left">
  <div class="fz-12 font-weight-bold  mb-1" >MODERADO</div>
  <div class="fz-12">
  Puedo aceptar fluctuaciones negativas, incluyendo posibles pérdidas en mi inversión inicial en el mediano plazo, con el fin de obtener tasas considerablemente mayores a las tasas activas vigentes por el BCV.
  </div>
</div>
` ,

'@i18n-quote-option-list-investorProfile-option3':

`
<div class="text-left">
  <div class="fz-12 font-weight-bold  mb-1" >CONSERVADOR</div>
  <div class="fz-12">
    Me gustaría preservar mi capital invertido, pero estoy dispuesto a aceptar pequeñas fluctuaciones en el valor del mismo, incluyendo posibles pérdidas en mi inversión inicial.   </div>
</div>
` ,

'@i18n-quote-investorProfile-form-label-profile': 


`
<div class="text-left mb-2">
  <div class="font-weight-bold  mb-1" >Perfil</div>
  <div class="text-secondary font-weight-normal ">
  Seleccione la opción de inversión que mejor describe su perfil de inversionista
  </div>
</div>
` ,

'@i18n-temConditions':

`

<b class="mb-2 text-center">Rendivalores Casa de Bolsa, C.A. (“Rendivalores”)</b>
<div>

Es una Casa de Bolsa supervisada por la Superintendencia Nacional de Valores (SUNAVAL) y miembro de la Bolsa de Valores de Caracas, que pone a disposición de personas naturales y jurídicas una Aplicación Móvil (“Aplicación”) como plataforma tecnológica de difusión de información financiera y económica, tanto de la República Bolivariana de Venezuela, como del exterior. Al descargar la Aplicación, crear una cuenta y/o utilizar cualquier servicio brindado por Rendivalores Casa de Bolsa, C.A., sociedad mercantil debidamente inscrita en el Registro Mercantil Segundo del Distrito Capital en fecha 17 de agosto de 1995, bajo el No. 27, Tomo 351-A-Sgdo de los Libros que lleva dicho Registro, autorizada por la Superintendencia Nacional de Valores en fecha 6 de octubre de 2017, miembro número 64 de la Bolsa de Valores de Caracas, representada por su Presidente, Juan Domingo Cordero Osorio, venezolano, mayor de edad, de estado civil soltero, domiciliado en la ciudad de Caracas y titular de la cédula de identidad N° V-20.910.299, en adelante “Rendivalores”, usted está aceptando y sometiéndose a los Términos y Condiciones aquí establecidos. Los Términos y Condiciones aquí establecidos se fijan para proteger tanto a Rendivalores como al Usuario, entendido éste como toda persona natural o jurídica que haga uso de los servicios ofrecidos en nuestra Aplicación. El Usuario deberá leerlos detalladamente antes de descargar y hacer uso de la Aplicación. 1. Capacidad Legal: Es responsabilidad de cada Usuario asegurarse de que cumplen con la legislación vigente de su jurisdicción antes de descargar la Aplicación y de abrir una cuenta o usar los servicios prestados por Rendivalores a través de su Aplicación. 2. Responsabilidad de Rendivalores: Las informaciones, datos, cotizaciones e indicadores difundidos en nuestra Aplicación tienen un carácter único y exclusivamente informativo y pueden provenir de terceros no relacionados con Rendivalores. El Usuario conoce y acepta que Rendivalores no garantiza la certeza, veracidad y actualización en tiempo real de las informaciones, datos, cotizaciones e indicadores difundidos en nuestra Aplicación. La difusión de informaciones, datos, cotizaciones e indicadores a través de la plataforma no representa en modo alguno, recomendación o sugerencia de compra, venta o inversión de instrumentos financieros de cualquier tipo. El Usuario exime de total responsabilidad a Rendivalores por cualquier clase de daño y/o pérdida que pueda sufrir él o un tercero por la utilización de las informaciones, datos, cotizaciones e indicadores difundidos en nuestra Aplicación. Rendivalores no se hace responsable ni necesariamente tiene por qué estar de acuerdo con las informaciones, opiniones y comentarios que se difundan en su Aplicación. 3. Modificación: Los Términos y Condiciones aquí expresados, podrán ser modificados por Rendivalores en cualquier momento, y empezarán a entrar en vigencia a los tres (03) días continuos desde el momento de su publicación en nuestra plataforma, con lo cual se entenderán como conocidos y aceptados por el Usuario. Todo Usuario que no esté de acuerdo con las modificaciones efectuadas podrá solicitar la baja de su cuenta en la Aplicación. 4. Funcionamiento: Rendivalores efectúa los mayores esfuerzos para la actualización en tiempo real de su contenido, mantenimiento y funcionamiento de su Aplicación, no pudiendo garantizar la ausencia de fallos técnicos, la infalibilidad del servicio, ni que la Aplicación se encuentre operativa y actualizada en su contenido en todo momento. El Usuario entiende que la disponibilidad y funcionalidad de los servicios que ofrece Rendivalores dependen de la señal de datos de su proveedor de servicios telefónicos o conexión a wifi, así como de otras circunstancias sobre las cuales Rendivalores no tiene control y que por ende no se le imputa ninguna responsabilidad. Los Usuarios no podrán imputarle responsabilidad alguna a Rendivalores, ni exigir resarcimiento alguno, en virtud de perjuicios resultantes de las mencionadas dificultades, así como por cualquier otra clase de daños, incluyendo daños indirectos, especiales o consecuentes que surjan o experimenten los Usuarios. 5. Registro de las Cuentas: A los fines de utilizar los servicios de Rendivalores, el Usuario debe registrarse en Rendivalores y aceptar estos Términos y Condiciones de uso de nuestros servicios. Para registrarse es obligatorio completar el formulario de registro en todos sus campos requeridos. Toda la información proporcionada por el Usuario en la inscripción en la plataforma Rendivalores debe ser precisa y completa en todos los aspectos requeridos. A los fines de la creación del perfil del Usuario de la Aplicación de Rendivalores será necesario que el Usuario proporcione la siguiente información: a) Nombres y Apellidos; b) Correo electrónico; y c) Número telefónico de contacto. Rendivalores se reserva el derecho de requerir información adicional, comprobantes y otros medios probatorios, así como de verificar e intercambiar la información del Usuario con terceros a los fines de comprobar la identidad y veracidad de la información suministrada. Rendivalores se reserva el derecho de rechazar cualquier solicitud de registro de Usuario o de cancelar o suspender, temporal o definitivamente su cuenta, si sus datos no pueden ser confirmados o en el caso de detectar incongruencias o inconsistencias en la información provista o actividades sospechosas, sin que tal decisión genere para el Usuario, derecho de indemnización o compensación alguna. La creación de un Perfil de Usuario de la Aplicación de Rendivalores no constituye al Usuario como cliente de Rendivalores, ni crea relaciones comerciales ni contractuales más allá de la simple prestación de los servicios que brinda la Aplicación. En caso de optar por inscribirse como clientes de Rendivalores se deberán cumplir con los requisitos estipulados en el artículo 46 de la Providencia 209 publicada en Gaceta Oficial Nro.42.115 de fecha 28 de abril de 2021. Rendivalores podrá actualizar estos Términos y Condiciones y en especial los requisitos que los Usuarios deben cumplir a los fines de adaptar la Aplicación a una plataforma que brinde la posibilidad de realizar operaciones en el mercado de valores de conformidad con la normativa vigente de la Superintendencia Nacional de Valores en cualquier momento. 6. Seguridad de las cuentas: Cada Usuario es totalmente responsable por mantener la confidencialidad de su cuenta, y debe hacer los esfuerzos necesarios y debida diligencia para prevenir su uso por parte de terceros no autorizados. Rendivalores se reserva el derecho de bloquear y restringir el acceso y funcionalidad de cualquier cuenta, cuya seguridad se vea, a su solo juicio, comprometida. Rendivalores no será responsable de pérdidas o daños que el Usuario o cualquier tercero pueda sufrir cuando nuestros servicios sean prestados de buena fe. 7. Cumplimiento de la legislación e impuestos aplicables: El Usuario es el único responsable de comprender y dar cumplimiento a todas y cada una de las leyes, normas y regulaciones que se le puedan aplicar en relación con el uso que haga de nuestros servicios, así como de la determinación y pagos de impuestos que se puedan originar por inversiones y operaciones en el mercado de valores. 8. Cancelación de cuentas: Rendivalores podrá dar por terminado sin previo aviso la prestación de sus servicios y dar de baja la cuenta del Usuario, por cualquiera de las siguientes circunstancias: a) Incumplimiento del Usuario a estos Términos y Condiciones o a la legislación vigente, reservándose el derecho de reclamar los daños y perjuicios que tal incumplimiento le haya causado. b) Por la ocurrencia de algún hecho fortuito, hecho de fuerza mayor, hecho del príncipe, decisión judicial y/o gubernamental que impida la prestación de nuestros servicios, en cuyo caso el Usuario o terceros no podrán exigir a Rendivalores responsabilidad o compensaciones, reembolsos de gastos, perjuicios por daño emergente, lucro cesante, daño moral o cualquier otro. c) Por decisión unilateral de Rendivalores, en cuyo caso el Usuario o terceros no podrán exigir a Rendivalores responsabilidad o compensaciones, reembolsos de gastos, perjuicios por daño emergente, lucro cesante, daño moral o cualquier otro. El Usuario podrá en cualquier momento solicitar la baja o cierre de su cuenta, esto no conlleva el cese de cualquier investigación que esté en curso ni el cumplimiento de las obligaciones que se hayan originado por el uso de nuestros servicios. 9. Usos prohibidos: El contenido de la Aplicación sólo puede ser empleado por el Usuario para beneficio propio acorde a las funcionalidades permitidas, así como a los usos autorizados en los presentes Términos y Condiciones. En virtud de lo anterior, el Usuario se obliga a no usar, comercializar, revelar a terceros, distribuir, difundir, regalar o de cualquier otro modo disponer de la información contenida en la Aplicación para fines distintos a los establecidos, ni podrá explotar por sí o por interpósita persona, ya sea en forma directa o indirecta, la misma sin la previa autorización por escrito de Rendivalores. El Usuario se obliga a emplear el contenido de la Aplicación de modo tal que no atente contra los presentes Términos y Condiciones, ni contra la legislación de la República Bolivariana de Venezuela ni del exterior, así como contra la moral, las buenas costumbres, la dignidad de la persona y los derechos de terceros. Si tenemos la sospecha o indicio de la utilización de nuestros contenidos para alguna actividad prohibida por la ley o Términos y Condiciones de Rendivalores podremos rechazar, cancelar y/o bloquear temporalmente el acceso y uso de su cuenta, la utilización o disponibilidad de funcionalidades o cancelar definitivamente la cuenta y acceso a la Aplicación. En tal caso, el Usuario deberá responder por los daños y perjuicios que pueda haber ocasionado a Rendivalores, a cuyos efectos nos reservamos el derecho de iniciar las acciones judiciales o extrajudiciales que estimemos pertinentes. El Usuario será exclusiva e ilimitadamente responsable por los daños y perjuicios que su conducta pueda causar. 10. Propiedad Intelectual: La aplicación móvil, su proyecto, diseño general, logo, marca, software, plataforma tecnológica, invenciones, mejoras, así como todos los negocios, proyectos, trabajos y contenidos desarrollados por Rendivalores, son de su propiedad exclusiva y absoluta, en ningún momento y bajo ningún concepto podrán ser utilizadas sin previa autorización por escrito de Rendivalores. 11. Notificaciones: Se reputarán como válidas todas las notificaciones realizadas a los Usuarios en la dirección de correo electrónico principal registrada por éstos. Será responsabilidad del Usuario mantener actualizado y funcional su correo electrónico, así como de aplicar las medidas que sean necesarias para que las notificaciones no sean recibidas como correo no deseado. 12. Integración: En el caso que cualquiera de las estipulaciones de los presentes Términos y Condiciones sean o lleguen a ser legalmente ineficaces o inválidas, la validez o eficacia de las demás disposiciones no será afectada. 13. Domicilio: Se fija como de domicilio de Rendivalores la ciudad Caracas, República Bolivariana de Venezuela. 14. Jurisdicción Aplicable: Estos Términos y Condiciones estarán regidos en todos sus puntos por las leyes vigentes en la República Bolivariana de Venezuela. Cualquier controversia derivada de su existencia, validez, interpretación, alcance o cumplimiento, será sometida de forma exclusiva y excluyente a las leyes aplicables y a los Tribunales competentes de la ciudad de Caracas, República Bolivariana de Venezuela.
Copyright © 2017 All market data provided by Barchart Solutions. BATS market data is at least 15-minutes delayed. Forex market data is at least 10-minutes delayed. AMEX, NASDAQ, NYSE and futures market data (CBOT, CME, COMEX and NYMEX) is end-of-day. Information is provided 'as is' and solely for informational purposes, not for trading purposes or advice, and is delayed. To see all exchange delays and terms of use, please see our disclaimer.

</div>`
,

'@i18n-new-product-body':`
<div class="mt-3 mb-2 font-weight-bold text-dark">Selecciona tu tipo de registro
                                </div>
                                <div class="text-secondary fz-12 text-left">
                                    <div>
                                    <i class="text-primary fas fa-square mr-1"></i>
                                        <b>Cuenta de Corretaje Bursátil Rendivalores </b> Invierte en el mercado de valores
                                    </div>
                                    <div class="mt-3">
                                    <i class="text-primary fas fa-square mr-1"></i>

                                        <b> Fondo Mutual Rendivalores</b> 

                                    </div>
                                </div>
                                `,


                                '@i18n-dashboard-title':`           <h4 class="text-dark font-weight-bold mt-5">
                                Potencia tu visión financiera.
                                </h4>
                                
                                <h6 class="text-secondary">
                                
                                <div class="mt-2"> Con la Cuenta de Inversión {clientName}, tienes un Ejecutivo de Negocio que colabora para brindarle<br> orientación financiera integrada y personalizada.
                                </div>
                                
                                
                                </h6>`,
                                '@i18n-new-product-box':`<div> Solicita la Cuenta <br>de Inversión<br></div>`,

 '@i18n-title-dashboard-transaction':`Completa tu registro`,

 '@i18n-body-dashboard-transaction':`
   
 <div class="circle-bg bg-2 ml-auto mr-auto text-center">
 
 <i class="fas fa-chart-line  "></i>
 </div>
 
 <div class="mt-3 font-weight-bold text-dark">Perfil Transaccional</div>
 
 
 
 <div class="mt-1  fz-13">
 Origen, destino y movilización de los fondos
 </div>
 `,

'@i18n-transaction-send-success': `<b>Felicitaciones</b> , tu solicitud esta lista.<br><br> Por favor procede a enviarla para que nuestros analistas la revisen.<br> <br> Te responderemos en un tiempo no mayor a 2 días hábiles una vez recibida la solicitud.<br><br> Si toda
la información está correcta y cumples con los requerimientos para invertir, tu Cuenta de Corretaje Bursátil  será creada en línea.  Recibirás un correo informándote que tu cuenta fue aprobada. Puedes contactar a tu ejecutivo para que te indique los pasos a seguir.`,

'@i18n-quote-option-list-investorObjetive-option1':'Seguridad',
'@i18n-quote-option-list-investorObjetive-option2':'Rentabilidad',
'@i18n-quote-option-list-investorObjetive-option3':'Apreciacion del capital'


};
 
 
 

 